export default {

    seleccionaNegocio: "Selecciona negocio...",

    filtraPorEtiqueta: "Filtra por etiqueta",

    noEncontramosResultadosPara: "No encontramos resultados para ",

    mostrando: "Mostrando",

    resultado: "resultado",

    resultados: "resultados",

    //ALMACÉN
    totalAlmacen: "Total Almacén",
    totalAlmacenDto: "Total Almacén Dto",
    existenciasTeoricas: "Existencias Teóricas",
    diferencia: "Diferencia",
    noContabilizado: "No contabilizado",

    seleccioneUnaFechaDeInicioYUnaFechaDeFin: "Seleccione una fecha de inicio y una fecha de fin",

    //INFORMES
    inicio: "Inicio",
    informes: "Informes",
    productos: "Productos",
    ventasPorNegocio: "Ventas por negocio",
    casas: "Casas",
    facturasSimplificadas: "Facturas simplificadas",
    comprasPorNegocio: "Compras por negocio",
    comprasPorCasas: "Compras por casas",
    gastosPorProveedor: "Gastos por proveedor",
    gastosPorSubproductos: "Gastos por materias primas",
    sage: "SAGE",
    sageplancuentas: "Plan de Cuentas",
    sageclientes: "Clientes",
    sageefectos: "Efectos",
    sageasientos: "Asiento Contable",

    //CASAS
    nuevaCasa: "Nueva casa",
    casa: "Casa",
    negocio: "Negocio",
    desde: "Desde",
    hasta: "Hasta",
    consultar: "Consultar",
    infoCasas: "Este consumo de casas proviene de los gastos introducidos en el rango de fecha seleccionado",
    exportarInforme: "Exportar informe",
    exportarPdf: "Exportar como PDF",
    exportarExcel: "Exportar como Excel",
    exportarExcelSinSubproductos: "Exportar como Excel con materias primas",

    //TABLA
    fecha: "Fecha",
    subproductos: "Materias primas",
    subproducto: "Materia prima",
    unidades: "Unidades",
    partes: "Partes",
    precio: "Precio",
    total: "Total",
    infoConsumo: "Este consumo de casas proviene de los gastos introducidos en el rango de fecha seleccionado",
    noHay: "No hay",
    gastos: "Gastos",
    rangoDeFechas: "en este rango de fecha.",
    configuracion: "Configuración",
    datosFiscales: "Datos Fiscales",

    // DATOS FISCALES
    nombreFiscal: "Nombre fiscal",

    //FORM CASA
    nombreCasa: "Nombre Casa",
    cifNif: "CIF NIF",
    direccion: "Dirección",
    provincia: "Provincia",
    ciudad: "Ciudad",
    codigoPostal: "Código postal",
    pais: "Pais",
    telefono: "Teléfono",
    correoElectronico: "Correo electrónico",
    iban: "IBAN",
    numeroRegistroSanitario: "Número registro sanitario",
    baja: "Baja",
    guardar: "Guardar",
    cancelar: "Cancelar",
    replicar: "Replicar en otros negocios",
    replicarCasa: "Replicar casa en otros negocios",
    seleccionarTodos: "Seleccionar todos",
    aceptar: "Aceptar",
    casaMin: "casas",

    //
    compras: "Compras",
    agregarCasa: "Añadir Casa",
    email: "Email",
    acciones: "Acciones",
    editar: "Editar",
    enEsteNegocio: "en este negocio.",

    //PLACEHOLDER
    introduzcaNombre: "Introduzca nombre",
    introduzcaCifNif: "Introduzca CIF / NIF",
    introduzcaDireccion: "Introduzca dirección",
    introduzcaProvincia: "Introduzca provincia",
    introduzcaCiudad: "Introduzca ciudad",
    introduzcaCodigoPostal: "Introduzca código postal",
    introduzcaTelefono: "Introduzca teléfono",
    introduzcaCorreo: "Introduzca correo electrónico",
    introduzcaIban: "Introduzca IBAN",
    introduzcaNumeroRegistroSanitario: "Introduzca número registro sanitario",
    buscar: "Buscar...",

    //PROVEEDORES
    proveedores: "Proveedores",
    agregarProveedor: "Agregar Proveedor",
    proveedor: "Proveedor",
    categoria: "Categoría",
    proveedoresMin: "proveedores",

    //FORM
    nombreProveedor: "Nombre Proveedor",
    acreedor: "Acreedor",
    infoAcreedor: "(Si un proveedor es acreedor no aparecerá en Numier TPV)",
    replicarProveedor: "Replicar proveedor en otros negocios",
    category: "Categoría",
    replicarCategory: "Replicar etiqueta en otros negocios",

    //ETIQUETAS
    etiquetas: "Etiquetas",
    etiqueta: "Etiqueta",
    sinEtiqueta: "Sin etiqueta",
    nuevaEtiqueta: "Nueva etiqueta",
    agregarEtiqueta: "Añadir etiqueta",
    tipo: "Tipo",
    etiquetaPadre: "Etiqueta Padre",
    tipoPadre: "Tipo Padre",

    //FORM
    nombreEtiqueta: "Nombre Etiqueta",

    //SUBPRODUCTOS
    agregarSubproducto: "Añadir Materia prima",
    precioCompra: "Precio de compra",
    escandallo: "Escandallo",
    subproductosCreados: "Materia Primas Creadas",
    nuevaCategoria: "Nueva categoría",
    materiaPrima: "Materia prima",
    materiasPrimas: "Materias primas",

    //FORM
    nuevoProveedor: "Nuevo Proveedor",
    nombreSubproducto: "Nombre Materia prima",
    codigoBarra: "Código de barras",
    descripcion: "Descripción",
    tipoIva: "Tipo I.V.A.",
    cuotaIVA: "Cuota IVA",
    ivaIncluido: "(IVA incluido)",
    descuentoCompra: "Descuento compra",
    porcentaje: "(% Porcentaje)",
    guardarEnAlmacen: "Guardar en almacén",
    stockMinimo: "Stock mínimo",
    stockOptimo: "Stock óptimo",
    gastosPorProveedoresUnidos: "Gastos por proveedores unidos",
    caracteresRestantes: "Caracteres restantes",

    //INFORME SUBPRODUCTO
    referencia: "Referencia",
    uds: "Uds",
    iva: "IVA",
    importe: "Importe",
    imp: "Imp.",
    sinDto: "SIN DTO.",
    importeConIva: "Importe con IVA",
    importeSinIva: "Importe sin IVA",
    importeSinIvaDto: "Importe sin IVA con Dto",
    precioUdSinIva: "Precio / ud sin IVA",
    dto: "Dto",
    ttal: "Total",

    //PRODUCTOS
    producto: "Producto",
    precioDeCoste: "Precio de coste",
    tarifa1: "Tarifa 1",
    tarifa2: "Tarifa 2",
    tarifa3: "Tarifa 3",
    tarifa4: "Tarifa 4",
    agregarProductos: "Añadir producto",
    noHayProductosEnEsteNegocio: "No hay productos en este negocio",
    sinCategoria: "Sin Categoría",
    cliente: "Cliente",

    //FORM
    nombreProducto: "Nombre producto",
    codigoDeBarra: "Código de barras",
    colorBoton: "Color del botón:",
    descuento: "Descuento",
    precioCoste: "Precio coste",
    opcionesAlSeleccionarElArticulo: "Opciones al seleccionar el producto",
    numeroDeOpcionales: "Número de materias primas opcionales",
    impresoraComandasTPV: "Impresora Comandas TPV",
    impresoraComandasPDA: "Impresora Comandas PDA",
    copiaImpresoraComandasTPV: "Copia Impresora Comandas TPV",
    copiaImpresoraComandasPDA: "Copia Impresora Comandas PDA",
    impresionPlano: "Impresora Plano ",
    impresionPlanoKDS: "Impresora Plano KDS",
    copiaImpresionPlano: "Copia Impresora Plano ",
    copiaImpresionPlanoKDS: "Copia Impresora Plano KDS",
    impresionPlano1: "Impresora Plano 1",
    impresionPlano2: "Impresora Plano 2",
    impresionPlano3: "Impresora Plano 3",
    impresionKDSTPV: "Enviar comanda desde TPV",
    impresionKDSPDA: "Enviar comanda desde PDA",
    copiaImpresionKDSTPV: "Copia comanda desde TPV",
    copiaImpresionKDSPDA: "Copia comanda desde PDA",
    pedirPrecio: "Pedir Precio",
    pedirPeso: "Pedir peso",
    pedirImporte: "Pedir Importe",
    promocionable: "Promocionable",
    mostrarPC: "Mostrar en PC",
    mostrarPDA: "Mostrar en PDA",
    noImprimir: "No Imprimir",
    numeroPlato: "Número de plato por defecto",
    seleccionIngredientes: "Activar selección de ingredientes",
    introduzcaDescripcion: "Introduzca descripción",
    introduzcaCodigoDeBarras: "Introduzca código de barras",
    introduzcaPrecioCoste: "Introduzca precio coste",
    opcion1: "Opción 1",
    opcion2: "Opción 2",
    opcion3: "Opción 3",
    opcion4: "Opción 4",
    opcion5: "Opción 5",
    numOpcionales: "Número de materias primas opcionales",

    //OPERARARIOS
    operarios: "Operarios",
    agregarOperario: "Añadir operario",
    apellido: "Apellido",
    nombreOperarios: "Nombre Operarios",
    pass: "Contraseña",
    salario: "Salario",
    passTurn: "Contraseña de turno",
    hombre: "Hombre",
    mujer: "Mujer",
    replicarProducto: "Replicar producto en otros negocios",
    introduzcaEscandallo: "Introduzca escandallo",
    introduzcaStockMinimo: "Introduzca stock mínimo",
    introduzcaStockOptimo: "Introduzca stock optimo",
    introduzcaPrecioCompra: "Introduzca precio compra",
    introduzcaApellido: "Introduzca apellido",
    introduzcaPass: "Introduzca Contraseña",
    introduzcaEmail: "Introduzca email",
    introduzcaSalario: "Introduzca salario",
    introduzcapassTurn: "Introduzca contraseña de turno",
    replicarOperario: "Replicar operario en otro negocio",
    TPV: "TPV",
    precioMed: "Precio Med.",
    precioMedSinIva: "Precio Med sin iva",
    porUnidad: "Por unidades",
    porImporte: "Por importe",
    contrasenya: "Contraseña PDA",
    repartidor: "Repartidor",
    buscaRepartidor: "buscaRepartidor",
    noMostrarEnVentas: "No mostrar en ventas",
    noHayOperariosEnEsteNegocio: "No hay operario en este negocio",
    VerDetalles: "Ver detalles",

    accesoDenegado: "Acceso Denegado",
    
    //CLIENTES
    cliente: "Cliente",
    clientes: "Clientes",
    companyia: "Campaña",
    agregarCliente: "Añadir cliente",
    nombreCliente: "Nombre cliente",
    saldo: "Saldo",
    infoCliente: "En el caso de utilizar tarjetas de saldo",
    tarifa: "Tarifa",
    descuentoImporte: "Descuento importe",
    noHayClientesEnEsteNegocio: "No hay clientes en este negocio",
    barCode: "Barcode",
    cuentaContableSocio: "Cuenta contable Socio",
    cuentaContableLevy: "Cuenta contable Levy",

    //IMPRESION
    impresionDeComandas: "Impresión de comandas",
    copiaDeImpresionDeComandas: "Copia de impresión de comandas",
    impresionPorPlana: "Impresión por plano",
    impresionPorKDS: "Impresión por KDS",
    monitorDeCocina: "Monitor de cocina",

    //INFORMES
    ventas: "Ventas",
    tarjetas: "Tarjetas",
    cheque: "Cheque",
    cambio: "Cambio",
    recuento: "Recuento",
    descuadre: "Descuadre",
    siguienteDia: "Siguiente día",
    incidencias: "Incidencias",
    recaudado: "Recaudado",
    noHayVentasEnEsteRangoDeFechas: "No hay ventas en este rango de fechas",
    tickets: "Tickets",
    factura: "Factura",
    noHayFormasDePagoEnEsteRangoDeFecha: "No hay formas de pago en este rango de fecha",
    desglose: "Desglose",
    sinBase: "Sin Base",
    base: "Base",
    impuesto: "Impuesto",
    facturasEmitidas: "Facturas nominativas",
    mesa: "Mesa",
    cifnif: "CIF/NIF",
    cobro: "Cobro",
    noHayFacturasEmitidasEnEsteRangoDeFecha: "No hay facturas emitidas en este rango de fechas",
    estadisticasAgencias: "Estadisticas Agencias",
    agencia: "Agencia",
    comentario: "Comen.",
    noHayEstadisticasDeAgenciaEnEsteRangoDeFechas: "No hay estadisticas de agencias en este rango de fechas",
    desglosesImpuestos: "Impuestos por cierre de caja",
    desglosesImpuestosAgencia: "Impuestos por agencia",
    noHayFormasDePagoEnEsteRangoDeFechas: "No hay formas de pago en este rango de fechas",
    cuentasAparcadas: "Cuentas a crédito",
    operacion: "Operación",
    operario: "Operario", //new
    noExisteDesgloseImpuestos: "No existe desglose de impuestos.", //new
    noHayCuentasAparcadasEnEsteRangoDeFechas: "No hay cuentas a crédito en este rango de fechas",
    noHayCuentasAnuladasEnEsteRangoDeFechas: "No hay cuentas anuladas en este rango de fechas",
    cierreCaja: "Cierre caja",
    fechaCierre: "Fecha cierre",
    venta: "Venta",
    totalRecaudado: "Total recaudado",
    noHayCierresDeCajaEnEsteRangoDeFecha: "No hay cierres de caja eneste rango de fechas",
    cierreCajaZ: "Cierre de Caja Z",

    //MODAL
    n: "Nº.",
    apertura: "Apertura",
    cierre: "Cierre",
    totalVenta: "Total Venta",
    efectivo: "Efectivo",
    tarjetaCheques: "Tarj+Cheques",
    totalTeorico: "Total teórico",
    totalEnArqueo: "Total en arqueo",
    cambioSig: "Cambio sig",
    volver: "Volver",
    confirmacionImportacionHeader: "Confirmación de importación",
    confirmacionImportacionText: "¿Estás seguro de que quieres importar?",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    registros: "registros",
    headerError: "ERROR",
    bodyError: "Por favor, inserte un archivo con menos de 10.000 registros",
    en: "En ",

    //OPERARIOS
    ventasPorOperarios: "Cuentas cobradas por operario",
    invitaciones: "Invitaciones",
    horas: "Horas",
    sueldo: "Sueldo",
    categorias: "Categorías",

    //CLIENTES
    ventasPorClientes: "Ventas por cliente",
    companya: "Empresa",
    consumiciones: "Consumiciones",
    media: "Media",
    mediaSesion: "Media sesión",

    //AGENCIAS
    noHayAgenciasEnEsteMomento: "No hay agencias en este momento",
    agencias: "Agencias",
    nombreAgencia: "Nombre agencia",
    comision: "Comisión",
    replicarAgencias: "Replicar agencia",
    agregarAgencias: "Añadir agencia",

    //MODIFICADORES
    nombreModificador: "Nombre modificador",
    grupos: "Grupos",
    variacion: "Variación",
    resta: "Resta",
    suma: "Suma",
    modificador: "Modificador",
    modificadores: "Modificadores",
    agregarModificador: "Añadir modificador",
    grupo: "Grupo",
    noHayModificadoresEnEsteNegocio: "No hay modificadores en este negocio",
    almacen: "Almacén",
    todos: "Todos",
    precioCompraConIva: "Precio compra CON IVA",
    precioCompraSinIva: "Precio compra SIN IVA",
    precioDescuentoSinIva: "Precio con descuento SIN IVA",
    codigoIdentificacion: "Código identificación",
    replicarModificador: "Replicar modificador",

    // SOPORTE ONLINE
    soporteOnline: "Soporte Online",
    soporteOnlineDetails: "Soporte Online - Detalles",
    abierto: "Abierto",
    esperandoRespuesta: "Esperando Respuesta",
    respondido: "Respondido",
    cerrado: "Cerrado",
    tecnico: "Técnico",
    comercial: "Comercial",
    facturacion: "Facturación",
    noTicketsEnNegocio: "No hay tickets en este negocio",
    responderTicket: "Responder ticket",
    mensaje: "Mensaje",
    cerrar: "Cerrar",
    enviarTicket: "Enviar Ticket",
    nuevoTicket: "Nuevo ticket",
    asunto: "Asunto",
    estado: "Estado",
    departamento: "Departamento",
    visitas: "Visitas",
    verTicket: "Ver ticket",
    tarjeta: "Tarjeta",

    //FORMAS DE PAGO
    nueva: "Nueva",
    replicarFormaDePago: "Replicar Forma de pago",
    nombreFormaPago: "Nombre forma de pago",
    formaDePago: "Forma de pago",
    formasDePago: "Formas de pago",
    agregarFormaDePago: "Añadir forma de pago",
    noHayFormasDePagoEnEsteNegocio: "No hay formas de pago en este negocio",
    nuevo: "Nuevo",

    //EDICIÓN MASIVA
    transferirProductosDeCategoria: "Transferir porductos de categoría",
    tranferir: "Transferir",
    impresionDeProductosDeCategorias: "Impresión de productos de categorías",
    impresoraComanda: "Impresora comanda",
    impresoraComandaTpv: "Impresora comanda TPV",
    impresoraComandaPda: "Impresora comanda PDA",
    copiaImpresionDeComanda: "Copia impresión de comandas",
    copiaImpresoraComandasTpv: "Copia impresora comandas TPV",
    copiaImpresoraComandasPda: "Copia impresora comandas PDA",
    impresionPorPlano: "Impresión por plano",
    enviarComandaDesdeTpv: "Enviar comanda desde TPV",
    enviarComandaDesdePda: "Enviar comanda desde PDA",
    respetarOtrasImpresiones: "¿Respetar otras impresiones?",
    cambioDePrecioProductos: "Cambio de precio productos",
    opcion: "Opción",
    tipoDeTarifa: "Tipo de tarifa",
    cambiarPrecio: "Cambiar precio",
    ajustes: "Ajustes",
    cambiarImpresionDeGrupo: "Cambiar impresión de grupo",
    tranferirProductosDeUnaCategoriaAOtra: "Transferir productos de una categoría a otra",
    cambiarPreciosAProductos: "Cambiar precios a productos",

    //WIDGETS
    consumoPorHoras: "Ventas por horas",
    productosMasVendidos: "Productos más vendidos",
    ultimosTickets: "Últimos tickets",
    verTodos: "Ver Todos",
    arqueoDeCaja: "Arqueo de Caja",
    cobrado: "Cobrado",

    cajaCerrada: "Caja Cerrada",
    licenciaCaducada: "Licencia Caducada",
    cajonInteligente: "Cajón inteligente",
    moneda: "Moneda",
    nivelReciclador: "Nivel Recicl.",
    totalReciclador: "Total Recicl.",
    nivelCasete: "Nivel Casete",
    totalCasete: "Total Casete",
    totalMonedas: "Total monedas",
    totalBilletes: "Total billetes",
    totalEnDirectoPorNegocio: "Ventas en directo por negocios/s",
    enCuenta: "En cuenta",
    cajaOnline: "Cajas Online",
    planoDeMesas: "Plano de mesas",
    planoDeTaquillas: "Plano de taquillas",
    nombrePlano: "Nombre plano",
    mesas: "Mesas",
    taquillas: "Taquillas",
    ocupacion: "Ocupación",
    enPlano: "En plano",
    desgloseTicket: "Desglose de ticket",
    precioMedio: "Precio medio",
    apuntado: "Apuntado",
    anulado: "Anulado",
    aparcado: "A crédito",
    indicencias: "Incidencias",
    filtrarOperario: "Filtrar operario",
    situacionActualDeLosNivelesDelCajonInteligente: "Situación actual de los niveles del cajón inteligente",
    verDetallesDeNiveles: "Ver detalles de niveles",
    noHayCajonInteligenteParaMostrar: "No hay cajón inteligente para mostrar",
    consulteConSuDistribuidor: "Consulte con su distribuidor",
    comparativaVentasAnteriores: "Comparativa ventas anteriores",
    graficaDeConsumoRespectoAHistoricoDeSesiones: "Gráfica de consumo respecto a histórico de sesiones",
    graficaDeConsumoAgrupadaPorTramosHorarios: "Gráfica de consumo agrupada por tramos",
    situacionActualDeOcupacionDeMesas: "Situación actual de ocupación de mesas",
    situacionActualDeOcupacionDeTaquillas: "Situación actual de ocupación de taquillas",
    verPlanoCompleto: "Ver plano completo",
    rankingDeLaSesionActual: "Ranking de la sesión actual",
    ultimosMovimientosDeLaCajaPorOperario: "Últimos movimientos de la caja por operario",
    estadoActualDeLaCaja: "Estado actual de la caja",
    turnosDeOperarios: "Turnos de operarios",
    relacionDeHorasTrabajadasYVentasRealizadasPorOperario: "Relación de horas trabajadas y ventas realizadas por operario",
    horarioInicio: "Hora inicio",
    horaFin: "Hora fin",
    horasTrabajadas: "Horas trabajadas",
    noHayTurnosDeOperarioParaMostrar: "No hay turnos de operarios para mostrar",
    propuestaDePedido: "Propuesta de pedido",
    pedidoAProveedor: "Pedido a proveedor",
    atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio: "Atención, hay movimientos de almacén que no se han descargado en el negocio",
    seleccionarNegocio: "Seleccionar negocio",
    seleccionarProveedor: "Seleccionar proveedor",
    generarPedidoEnBlanco: "Generar pedido en blanco",
    generarPedido: "Generar pedido",
    propuestaDePedidoA: "Propuesta de pedido a ",
    buscarMateriaPrimaEnElMismoProveedor: "Buscar materia prima en el mismo proveedor",
    precioIVAIncluido: "Precios IVA incluídos",
    ref: "Ref",
    nombre: "Nombre",
    existencias: "Existencias",
    pedido: "Pedido",
    precioArticuloUnidad: "Precio artículo / und",
    precioPedido: "Precio Pedido",
    sinIVA: "Sin IVA",
    porcentajeIVA: "% IVA",
    precioIVA: "Precio IVA",
    porcentajeDto: "% Dto",
    totalIVA: "Total IVA",
    observaciones: "Observaciones",
    noHaySubproductosEnEsteNegocioParaRealizarElPedido: "No hay subproductos en este negocio para realizar el pedido",
    recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo: "Recuerde que para que aparezcan los subproductos deben de estar a sociados a un proveedor y configurados el stock mínimo y stock  óptimo",
    guardarPedido: "Guardar pedido",
    totalIVAInc: "Total IVA Inc.",
    pedidosAProveedor: "Pedido a proveedor",
    fechaInicio: "Fecha inicio",
    fechaFin: "Fecha fin",
    pedidosConvertidos: "Pedidos covertidos",
    nuevoPedido: "Nuevo pedido",
    enviarPedidos: "Enviar pedidos",
    convertido: "Convertido",
    convertirEnGasto: "Convertir en gasto",
    modificar: "Modificar",
    eliminar: "Eliminar",
    descargarComoPDF: "Descargar como PDF",
    descargarComoPDFSinPrecios: "Descargar como PDF sin precios",
    descargarComoExcel: "Descarcar como Excel",
    descargarComoExcelSinPrecios: "Descargar como excel sin precios",
    enviarPorCorreo: "Enviar por correo",
    eliminarListaCorreo: "Eliminar lista correo",
    anyadirListaCorreo: "Añadir lista correo",
    noHayPedidosAEsteProveedorEnEsteRangoDeFecha: "No hay pedidos a este proveedor en este rango de fecha",
    enviarPedido: "Enviar pedido",
    enviarPedidoA: "Enviar pedido a",
    formato: "Formato",
    PDF: "PDF",
    excel: "Excel",
    conPrecios: "Con precios",
    sinPrecios: "Sin precios",
    convertirPedido: "Convertir pedido",
    tipoDeDocumento: "Tipo de documento",
    albaran: "Albarán",
    generarEntradaEnAlmacenAlVerificar: "Generar entrada en almacén al verificar",
    gastosDeCasas: "Gastos de casas",
    gastosPorCasa: "Gastos por casa",
    noHayGastosPorCasasEnEsteRangoDeFechas: "No hay gastos por casas en este rango de fechas",
    ventasDeCategorias: "Ventas de categorías",
    ventasCategoriaDe: "Ventas categoría de ",
    volverAGeneral: "Volver a general",
    ventasDeProductos: "Ventas de productos",
    filtrarPorTPV: "Filtrar por TPV",
    filtrarTPV: "Filtrar TPV",
    turnosDe: "Turnos de ",
    enActivo: "En activo",
    ventasDeProductosDe: "Productos de cuentas cobradas por ",
    ventasOperarios: "Cuentas cobradas",
    costesDeProductos: "Costes de productos",
    totalImportesVentas: "Total Importes Ventas",
    totalCoste: "Total coste",
    costes: "Costes",
    costeUd: "Coste Ud",
    coste: "Coste",
    porcentajeCosto: "% Costo",
    varCostoMed: "Var. Costo Med.",
    listaDeInvitaciones: "Lista de invitaciones",
    valor: "Valor",
    volverALaLista: "Volver a la lista",
    ventasDeProductosGlobal: "Ventas de productos global",
    porUnidades: "Por unidades",
    gastosPorEtiquetas: "Gastos por etiquetas",
    desgloseDeGastos: "Desglose de gastos",
    referencias: "Referencias",
    concepto: "Concepto",
    gastosDeProveedores: "Gastos de proveedores",
    sinProveedor: "Sin Proveedor",
    sinCasas: "Sin casas",
    cierreDeCaja: "Cierre de caja",
    primerTicket: "Primer Ticket",
    ultimoTicket: "Último ticket",
    cheques: "Cheques",
    cambioSigDia: "Cambio sig. día",
    ventasPorAgencias: "Ventas por agencias",
    ventasPorFormasDePago: "Ventas por forma de pago",
    exportarComoHTML: "Exportar como HTML",
    pendiente: "Pendiente",
    gasto: "Gasto",
    desgloseDeImpuestos: "Desglose de impuestos",
    desgloseDelTicket: "Desglose del ticket",
    cuentasAnuladas: "Cuentas anuladas",
    buscarPorHoras: "Buscar por horas",
    buscarBaja: "Mostrar productos de baja",
    buscarSubProductoBaja: "Mostrar materias primas de baja",
    buscarCategoriasBaja: "Mostrar categorías de baja",
    buscarEtiquetasBaja: "Mostrar etiquetas de baja",
    mostrarVentasAcumuladasPorDia:"Mostrar ventas acumuladas por día", 
    seleccionaUnTpv:"Debes seleccionar un TPV para ver sus detalles",
    deshabilitarCheckboxVentasAcumuladasPorDia:"Deshabilita el checkbox 'Mostrar ventas acumuladas por dia' para ver los detalles.",
    graficas: "Gráficas",
    dias: "Días",
    semanas: "Semanas",
    meses: "Meses",
    ventasPorComensales: "Ventas por comensales",
    numeroDeComensales: "Número de comensales",
    precioMedioPorComensal: "Precio medio por comensal",
    ventasPorRangosHorarios: "Ventas por rangos horarios",
    ops: "Ops",
    comensales: "Comensales",
    detalleDeOperaciones: "Detalle de operaciones",
    operaciones: "Operaciones",
    operacionMedia: "Operación media",
    detalleDeComensales: "Detalle de comensales",
    comensalMedio: "Comensal medio",
    noHayVentasEnLosRangosDeFechasDefinidos: "No hay ventas en los rangos de fechas definidos",
    transferencia: "Transferencia",
    domiciliacion: "Domiciliación",
    fechaGasto: "Fecha gasto",
    generarEntradaDeAlmacenAlVerificar: "Generar entrada de almacén al verificar",
    listaDeMateriaPrima: "Lista de materia prima",
    preciosIVAIncluido: "Precios IVA incluido",
    precioSinIVA: "Precio sin IVA",
    precioIVAInc: "Precio IVa inc",
    IVA: "IVA",
    totalBase: "Total base",
    totalDocumento: "Total documento",
    seleccioneUnaCasa: "Seleccione una casa",
    anyadirNuevoSubproducto: "Añadir nuevo subproducto",
    gestionDeGastos: "Gestión de gastos",
    deCaja: "De caja",
    fueraDeCaja: "Fuera de caja",
    contabilizado: "Contabilizado",
    si: "Si",
    no: "No",
    grafica: "Gráfica",
    lista: "Lista",
    avanzado: "Avanzado",
    noHayVentasDeProductosEnEsteRangoDeFechas: " No hay ventas de productos en este rango de fechas",
    historicoDeProductos: "Histórico de productos",
    volverA: "Volver a",
    general: "General",
    historialAlmacen: "Historial almacén",
    listadoDeExistencia: "Listado de existencia",
    listadoDeAlmacen: "Listado de Almacén",
    listadoHastaStockOptimo: "Listado hasta stock óptimo",
    listadoExistenciaBajoMinimo: "Listado existencia bajo mínimo",
    exportarValoracion: "Exportar valoración",
    importeDto: "Importe Dto",
    detalleDelSubproducto: "Detalle del subproducto",
    nombreNegocio: "Nombre negocio",
    noHaySubproductosConElMismoNombreEnTusOtrosNegocios: "No hay subproductos con el mismo nombre en tus otros negocios",
    detalleAlmacen: "Detalle almacén",
    entrada: "Entrada",
    inventario: "Inventario",
    salida: "Salida",
    valorDto: "Valor Dto.",
    noHayDatosEnEsteMovimientoDeAlmacen: "No hay datos en este movimiento de almacén",
    historial: "Historial",
    noHayMovimientoEnEstaMateriaPrima: "No hay movimiento en esta materia prima",
    dia: "Día",
    historialDeAlmacen: "Historial de almacén",
    inventarios: "Inventarios",
    entradas: "Entradas",
    salidas: "Salidas",
    completado: "Completado",
    verificado: "Verificado",
    descargado: "Descargado",
    diaActual: "Día actual",
    movimientos: "Movimientos",
    enEsteRangoDeFechas: "en este rango de fechas",
    rangosHorarios: "Rangos horarios",
    nuevoRangoHorario: "Nuevo rango horario",
    verUnInformeDeRangosHorarios: "Ver informe de rangos horarios",
    noHayRangosHorariosEnEsteNegocio: "No hay rangos horarios en este negocio",
    nombreRangosHorarios: "Nombre rangos horarios",
    vistaMosaico: "Vista mosaico",
    vistaLista: "Vista lista",
    ordenarProductos: "Ordenar productos",
    BAJA: "BAJA",
    frontalDeVenta: "Frontal de venta",
    agregarGasto: "Añadir gasto",
    entrAlmac: "Entr. Almac.",
    contab: "Contab",
    tranferencia: "Transferencia",
    verificar: "Verificar",
    entradaAlmacen: "Entrada de almacén",
    preciosIVAInluido: "Precios IVA Incluido",
    estaEntradaNoContieneNingunSubproducto: "Esta entrada no contiene ningún subproducto",
    cajasOnline: "Cajas online",
    minimo: "Mínimo",
    optimo: "Óptimo",
    posicionGlobal: "Posición global",
    empresa: "Empresa",
    ventasSinIVA: "Ventas sin IVA",
    neto: "Neto",
    fechaDeCumpleanyos: "Fecha de cumpleaños",
    recargoEquivalencia: "Recargo equivalencia",
    anyadirMateriaPrima: "Añadir Materia prima",
    partesT1: "Partes T1",
    partesT2: "Partes T2",
    partesT3: "Partes T3",
    partesT4: "Partes T4",
    costeDto: "Coste Dto",
    agregarMateriasPrimas: "Añadir Materias primas",
    frontalDeVentas: "Frontal de ventas",
    unidadesEnOtroNegocios: "Unidades en otros negocios",
    historialMateriaPrima: "Historial materia prima",
   
    borrarRangoHorario: "Borrar rango horario",
    detallesDeLaEntradaEnAlmacen: "Detalles de la entrada en almacén",
    desgloseHorasTrabajadas: "Desglose horas trabajadas",
    verProductosVendidos: "Ver productos vendidos",
    verTicketsDelProducto: "Ver tickets del producto",
    verTicketsDeEsasInvitaciones: "Ver tickets de esas invitaciones",
    verTicketsDeEsaAgencia: "Ver tickets de esa agencia",
    gastosPorMateriasPrimas: "Gastos por materias primas",
    alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta: "Al dar un producto de baja desaparece en el TPV para su venta pero sigue apareciendo en los informes de venta",
    cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta: "Cuando un producto es de tipo descuento su precio se descuenta del total de la cuenta",
    alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo: "Al activar esta opción aparece los ingredientes del producto para seleccionarlos",
    alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo: "Al activar esta opción puede seleccionar el precio del producto al marcarlo",
    alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo: "Al activar esta opción puede seleccionar el peso del producto al marcarlo",
    alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo: "Al activar esta opción puede seleccionar el importe del producto al marcarlo",
    alActivarEstaOpcionElProductoNoApareceraEnNumierTPV: "Al activar esta opción el producto no aparecerá en Numier TPV",
    alActivarEstaOpcionElProductoNoApareceraEnLaPda: "Al activar esta opción el producto no aparecerá en Numier PDA",
    alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada: "Al activar esta opción el producto no se imprimirá en el pendiente de cobro ni en la factura simplificada",
    guardarMateriaPrima: "Guardar materia prima",
    copiarMateriaPrima: "Copiar materia prima",
    seleccioneQueTipoDeMateriasPrimasQuiereCopiar: "Selecciones que tipo de materias primas quiere copiar",
    seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas: "Seleccione a que categorías quiere copiar las materias primas",
    copiaMateriaPrima: "Copia materia prima",
    notas: "Notas",
    pedidos: "Pedidos",
    atencionLaMediaSinContarLosDiasConVentas: "Atención: La media sin contar los días con ventas a 0€ es de: ",
    verDesgloseDeImpuestos: "Ver desglose de impuestos",
    verDetallesDetTicket: "Ver detalles del ticket",
    facturasNominativas: "Facturas nominativas",
    verDetallesDeGasto: "Ver detalles de gasto",
    desgloseDeGastosPorEtiquetasHijas: "Desglose de gastos por etiquetsa hijas",
    procedencia: "Procedencia",
    suLicenciaDeNumierOnlineEstaAPuntoDeCaducar: "Su licencia de Numier Online está a punto de caducar",
    cajasOnlineTickets: "Cajas Online Tickets",
    cajasOnlineDetalles: "Cajas Online Detalles",
    cajasOnlinePlano: "Cajas Online Plano",
    cajasOnlineProductos: "Cajas Online Productos",
    transferir: "Transferir",
    herramientas: "Herramientas",
    ver: "Ver",
    detallesDeLaentradaEnAlmacen: "Detalles de la entrada en el almacén",
    ups: "Ups",
    laFechaDeInicioNoPuedeSerPosteriorALaDeFin: "La fecha de inicio no puede ser posterior a la de fin",
    exportarContabilidad: "Exportar contabilidad",
    //NUEVO==========================   
    seleccioneUnProveedor: "Seleccione un proveedor",
    detallesDelPedido: "Detalles del pedido",
    correoEnviadoCorrectamente: "Correo enviado correctamente",
    atencion: "Atención",
    debeIntroducirUnEmailParaEnviarElPedido: "Debe introducir un email para enviar el pedido",
    detalles: "Detalles",
    gastoVerificadoCorrectamente: "Gasto verificado correctamente",
    estasSeguroDeEliminarElPedido: "¿Estás seguro de eliminar el pedido?",
    estaOperacionNoSePuedeDeshacer: "Esta operación no se puede deshacer",
    siEliminarPedido: "Sí, eliminar pedido",
    pedidoEliminadoCorrectamente: "Pedido eliminado correctamente",
    laReferenciaEsObligatoria: "La referencia es obligatoria",
    seleccioneLosNegociosParaHacerelPedido: "Seleccione los negocios para hacer el pedido",
    noHayProveedoresEnEsteNegocio: "No hay proveedores en este negocio",
    cuentasRectificadas: "Facturas rectificativas",
    noHayCuentasRectificadasEnEsteRangoDeFechas: "No hay cuentas rectificadas en este rango de fechas",
    pedidosProveedor: "Pedidos proveedor",
    gestionDePersonal: "Gestión de personal",
    configuracionCarta: "Configuración carta",
    importacionExcels: "Importación Excels",
    carta: "Carta digital",
    camaras: "Cámaras",
    perfil: "Perfil",
    cerrarSesion: "Cerrar sesión",
    desarrolladoPorNexodoDigitalSL: "Desarrollado por Nexodo Digital S.L.",
    totalValores: "Total Valores",
    totalValoresDto: "Total Valores Dto.",
    totalValoresRecuento: "Total Valores de Recuento",
    ultimoInventario: "Último inventario",
    filtrarEntreInventarios: "Filtrar entre inventarios",
    ultInventario: "Ult. inventario",
    primerInventario: "Primer inventario",
    marcaDosInventariosParaVerLosDetallesEntreEllos: "Marca dos inventarios para ver los detalles entre ellos",
    salir: "Salir",
    anadirMovimientoAlmacen: "Añadir Movimiento Almacén",
    nuevoInventario: "Nuevo Inventario",
    tienesUnInventarioSinTerminarElDia: "Tienes un inventario sin terminar el día",
    pulseElBotonRealizarInventarioPara: "Pulse el botón 'Realizar inventario' para",
    volverARealizarlo: "volver a realizarlo",
    siDeseas: "Si deseas",
    comenzarElInventarioDeNuevo: "comenzar el inventario de nuevo",
    comaMarqueLaCasillaEliminarDatosDeInventarioActual: ", marque la casilla 'Eliminar datos de inventario actual'",
    eliminarDatosDelInventarioActual: "Eliminar datos del inventario actual",
    realizarInventario: "Realizar inventario",
    accesoDenegado: "Acceso denegado",
    soloPuedeComprobar2InventariosAlMismoTiempo: "Solo puede comprobar 2 inventarios al mismo tiempo",
    cargando: "Cargando...",
    configuracionAlmacen: "Configuración almacén",
    actualizada: "actualizada",
    correctamente: "correctamente",
    noSeAdmitenCamposEnBlanco: "No se admiten campos en blanco",
    todas: "Todas",
    categoriaClientes: "Categoría clientes",
    seleccionaCompania: "Selecciona compañía",
    agregarCategoriaDeClientes: "Agregar categoría de clientes",
    categoriaPadre: "Categoría Padre",
    elCampoNombreFiscalEsObligatorio: "El campo nombre fiscal es obligatorio",
    elCampoCifNifEsObligatorio: "El campo Cif Nif es obligatorio",
    datosActualizadosCorrectamente: "Datos actualizados correctamente",
    elCampoNombreEsRequerido: "El campo nombre es requerido",
    creada: "creada",
    rangoHorario: "Rango horario ",
    soloPuedeCrearUnMaximoDeXRangosHorarios: "Solo puede crear un máximo de 12 rangos horarios",
    deAcuerdo: "De acuerdo",
    rangoHorario: "Rango horario ",
    eliminado: "eliminado",
    deseaEliminarEsteRangoHorario: "¿Desea eliminar este rango horario",
    siBorrarRangoHorario: "Sí, borrar rango horario",
    ordenarProductosAlfabeticamente: "Ordenar productos alfabéticamente",
    ordenarMateriasPrimasAlfabeticamente: "Ordenar materias primas alfabéticamente",
    asignarImpresorasSeleccionadasEnBlanco: "Asignar impresoras seleccionadas en blanco",
    aplicarCambios: "Aplicar cambios",
    ordenarAlfabeticamenteProductos: "Ordenar alfabéticamente productos",
    ordenar: "Ordenar",
    ordenarAlfabeticamenteSubproductos: "Ordenar alfabéticamente subproductos",
    seleccioneElTipo: "Seleccione el tipo",
    impresionDeProductosEfectuadaCorrectamente: "Impresión de productos efectuada correctamente",
    tienesQueSeleccionarUnaCategoria: "Tienes que seleccionar una categoría",
    ningunaSeleccionada: "Ninguna seleccionada",
    transferenciaDeProductosEfectuadaCorrectamente: 'Transferencia de productos efectuada correctamente',
    relleneLosCamposObligatorios: "Rellene los campos obligatorios",
    vistaFrontalTpv: "Vista frontal TPV",
    editarPrecios: "Editar precios",
    cancelarEdicion: "Cancelar edición",
    guardarOrden: "Guardar orden",
    bajaConBrackets: "[BAJA]",
    seleccionaUnaCategoria: "Selecciona una categoría...",
    cambiarImpresorasAProductos: "Cambiar impresoras a productos",
    igualar: "Igualar",
    sumar: "Sumar",
    restar: "Restar",
    multiplicar: "Multiplicar",
    todasLasTarifas: "Todas las tarifas",
    productosEditadosCorrectamente: "Productos editados correctamente",
    ordenActualizadoCorrectamente: 'Orden actualizado correctamente',
    componentesDeVenta: "Componentes de venta",
    delNegocioAClientes: "del negocio a clientes",
    clasificacionDe: "Clasificación de",
    productosPorFamilia: "productos por familia",
    elementosQue: "Elementos que",
    varianALosProductos: "varian a los productos",
    paraLaComanda: "para la comanda",
    componentesComprados: "Componentes comprados",
    aProveedoresQueComponenProductos: "a proveedores que componen productos",
    empresas: "Empresas",
    proveedorasDeMateriasPrimasYServicios: "proveedoras de materias primas y/o servicios",
    alNegocio: "al negocio",
    fabricantesDeMateriasPrimas: "fabricantes de materias primas",
    aProveedores: "a proveedores",
    categoriasQueClasifican: "Categorías que clasifican",
    materiasPrimasYProveedores: "materias primas y proveedores",
    personalCon: "Personal con",
    acceso: "acceso",
    alSistema: "al sistema",
    baseDeDatosDe: "Base de datos de",
    consumidores: "consumidores",
    enElNegocio: "en el negocio",
    clasificacionDeLa: "Clasificación de la",
    deLasVentas: "de las ventas",
    metodosDeCobro: "Métodos de cobro",
    enElFrontalDeVenta: "en el frontal de venta",
    intervaloDeHorasParaConsultarVentas: "Intervalo de horas para consultar ventas",
    configurarAlmacén: "Configurar almacén",
    relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen: "Relación de materias primas para la configuración del almacén",
    herramientasGenerales: "Herramientas generales",
    edicionMasiva: "Edición masiva",
    categoriasCarta: "Categorías carta",
    categoriaCarta: "categoría carta",
    orden: "Orden",
    editada: "editada",
    anadirCategoria: "Añadir categoría",
    esteNegocioNoTieneAccesoAEsteModulo: "Este negocio no tiene acceso a este módulo",
    paraMasInformacionContacteConSu: "Para más información contacte con su",
    distribuidor: "distribuidor",
    formasDePagoCarta: "Formas de pago carta",
    formaDePagoCarta: "forma de pago carta",
    informacionCarta: "Información carta",
    datosDelNegocio: "Datos del negocio",
    nombreMostrado: "Nombre mostrado",
    telefonoWhatsapp: "Teléfono WhatsApp",
    datosPedidos: "Datos pedidos",
    tiempoMedioDePreparacionRecogidaMin: "Tiempo medio de preparación recogida (min)",
    tiempoMedioDePreparacionDomicilioMin: "Tiempo medio de preparación domicilio (min)",
    gastosDeEnvio: "Gastos de envío",
    pedidoMinimo: "Pedido mínimo",
    interfaz: "Interfaz",
    textoEntrega: "Texto entrega",
    textoPresentacion: "Texto presentación",
    textoFormasDePago: "Texto formas de pago",
    textoHorarios: "Texto horarios",
    datosGuardadosCorrectamente: "Datos guardados correctamente",
    materiasPrimasCarta: "Materias primas carta",
    materiaPrimaCarta: "materia prima carta",
    referenciaMateriasPrimasTpv: "Referencia materias primas Tpv",
    nombreDeLaMateriaPrimaEnElTpv: "Nombre de la materia prima en el tpv",
    disponible: "Disponible",
    replicarMateriaPrima: "Replicar materia prima",
    replicarMateriasPrimas: "Replicar materias primas",
    nombreTpv: "Nombre Tpv",
    noDisponible: "No disponible",
    replicarTodasLasMateriasPrimas: "Replicar todas las materias primas",
    estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados: '¿Estás seguro de replicar todas las materias primas a los negocios seleccionados?',
    estaAccionNoSePuedeDeshacer: '¡Esta acción no se puede deshacer!',
    siReplicar: 'Sí, replicar',
    productosCarta: 'Productos carta',
    productoCarta: 'producto carta',
    referenciaProductoTpv: 'Referencia producto Tpv',
    nombreDelProductoEnElTpv: 'Nombre del producto en el tpv',
    seleccionaCategoria: "Selecciona categoría",
    seleccionaTipo: "Selecciona tipo",
    nIngredientesSinCosto: "Nº ingredientes sin costo",
    maximoExtras: "Máximo extras",
    alergenos: "Alérgenos",
    nombreTarifa1: "Nombre tarifa 1",
    precioTarifa1: "Precio tarifa 1",
    nombreTarifa2: "Nombre tarifa 2",
    precioTarifa2: "Precio tarifa 2",
    nombreTarifa3: "Nombre tarifa 3",
    precioTarifa3: "Precio tarifa 3",
    nombreTarifa4: "Nombre tarifa 4",
    precioTarifa4: "Precio tarifa 4",
    imagen: "Imagen",
    copiarMateriasPrimas: "Copiar materias primas",
    basico: "Básico",
    buscarNombreDeLaMateriaPrima: "Buscar nombre de la materia prima",
    seleccionaTipoPunto: "Selecciona tipo...",
    bases: "Bases",
    opcionales: "Opcionales",
    extras: "Extras",
    cereales: "Cereales",
    crustaceos: "Crustáceos",
    huevos: "Huevos",
    pescado: "Pescado",
    cacahuetes: "Cacahuetes",
    soja: "Soja",
    leche: "Leche",
    frutosDeCascara: "Frutos de cáscara",
    apio: "Apio",
    mostaza: "Mostaza",
    granosDeSesamo: "Granos de sésamo",
    dioxidoDeAzufre: "Dióxido de azufre",
    altramuces: "Altramuces",
    moluscos: "Moluscos",
    cartaASecas: "Carta",
    extra: "Extra",
    opcional: "Opcional",
    estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos: 'Este proceso borrara las materias primas actuales en las categorías seleccionadas de los tipos elegidos',
    aceptarProceso: "Aceptar proceso",
    necesitasMarcarAlMenosUnTipoYUnaCategoria: "Necesitas marcar al menos un tipo y una categoría",
    materiaPrimaCopiadaCorrectamente: "Materia prima copiada correctamente",
    editado: "editado",
    agregada: "agregada",
    relacion: "Relación",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: "No puede haber dos materias primas con el mismo tipo",
    estasSeguroDeBorrarLaMateriaPrima: "¿Estás seguro de borrar la materia prima?",
    siDeseoBorrarlo: "Sí, deseo borrarlo",
    seleccionaUnaCarta: "Selecciona una carta",
    replicarProductos: "Replicar productos",
    verCarta: "Ver carta",
    verPedido: "Ver pedido",
    verQR: "Ver QR",
    nombreEnTpv: "Nombre en tpv",
    cartaYPedido: "Carta y Pedido",
    replicarTodosLosProductos: "Replicar todos los productos",
    editarImagen: "Editar imagen",
    esteNegocioNoContieneNingunaCarta: "Este negocio no contiene ninguna carta",
    estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados: '¿Estás seguro de replicar todas los productos a los negocios seleccionados?',
    sustanciasQue: "Sustancias que",
    componenALosProductos: "componen a los productos",
    informacionAcercaDel: "Información acerca del",
    negocioMinuscula: "negocio",
    actualizarPedidos: "Actualizar pedidos",
    pendienteDeConfirmacion: "Pendiente de confirmación",
    confirmados: "Confirmados",
    enPreparacion: "En preparación",
    finalizados: "Finalizados",
    recogida: "Recogida",
    domicilio: "Domicilio",
    noHayPedidosPendientesDeConfirmacion: "No hay pedidos pendientes de confirmación",
    noHayPedidosConfirmados: "No hay pedidos confirmados",
    noHayPedidosEnPreparacion: "No hay pedidos en preparación",
    noHayPedidosTerminados: "No hay pedidos terminados",
    siBorrarPedido: "Sí, borrar pedido",
    estasSeguroDeSuspenderElServicioEnMesas: "¿Estás seguro de suspender el servicio en mesas?",
    siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo: "Si suspende el servicio en mesas, no entrarán más pedidos en mesa hasta activarlo de nuevo",
    siSuspenderElServicioEnMesa: "Sí, suspender el servicio en mesa",
    estasSeguroDeActivarElServicioEnMesas: "¿Estás seguro de activar el servicio en mesas?",
    siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa: "Si activa el servicio de mesas, volverán a entrar pedidos de mesa",
    siActivarElServicioEnMesa: "Sí, activar el servicio en mesa",
    estasSeguroDeSuspenderElServicio: "¿Estás seguro de suspender el servicio?",
    siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo: "Si suspende el servicio, no entrarán más pedidos hasta activarlo de nuevo",
    siSuspenderElServicio: "Sí, suspender el servicio",
    estasSeguroDeActivarElServicio: "¿Estás seguro de activar el servicio?",
    siActivaElServicioVolveranAEntrarPedidos: "Si activa el servicio, volverán a entrar pedidos",
    siActivarElServicio: "Sí, activar el servicio",
    pedidoAceptadoCorrectamente: "Pedido aceptado correctamente",
    pedidoEnPreparacion: "Pedido en preparación",
    pedidoFinalizado: "Pedido finalizado",
    pedidoArchivado: "Pedido archivado",
    servicioActualizadoCorrectamente: "Servicio actualizado correctamente",
    estasSeguroDeEditarLaObservacion: "¿Estás seguro de editar la observación?",
    siEditarObservacion: "Sí, editar observación",
    mesasActivadas: "MESAS⠀ACTIVADAS⠀",
    mesasDesactivadas: "MESAS⠀DESACTIVADAS⠀",
    crearNuevoProveedor: "Crear nuevo proveedor",
    crearMateriaPrima: "Crear Materia Prima",
    eliminarMateriaPrima: "Eliminar Materia Prima",
    sinCasaAsignada: "Sin casa asignada",
    buscarPorRefONombreDeLaMateriaPrima: "Buscar por Ref. o Nombre de la materia prima",
    mensajePorcentajeCompraAumento: "El precio ha aumentado del porcentaje de compra establecido",
    mensajePorcentajeCompraDisminuido: "El precio ha disminuido del porcentaje de compra establecido",

    seleccioneEtiqueta: "Seleccione etiqueta...",
    unidadesStockMinimo: "Unidades stock mínimo",
    partesStockMinimo: "Partes stock mínimo",
    anadirProveedor: "Añadir proveedor",
    amarillo: "amarillo",
    cajas: "Cajas",
    botellas: "Botellas",
    barriles: "Barriles",
    palets: "Palets",
    bolsas: "Bolsas",
    litros: "Litros",
    rollos: "Rollos",
    visualizar: "Visualizar",
    sinCasa: "Sin casa",
    elProveedorEsObligatorio: "El proveedor es obligatorio",
    laFechaEsObligatoria: "La fecha es obligatoria",
    hayUnaMateriaPrimaSinUnidades: "Hay una materia prima sin unidades",
    hayUnaMateriaPrimaSinPrecio: "Hay una materia prima sin precio",
    guardandoGasto: "Guardando gasto...",
    actualizado: "actualizado",
    creado: "creado",
    laLongitudDelNombreNoPuedeSerMayorDe: "La longitud del nombre no puede ser mayor de ",
    relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar: "Rellene todos los datos marcados con * antes de enviar",
    seleccionaProveedor: "Selecciona proveedor...",
    filtrarPorFecha: "Filtrar por fecha",
    convertirAlbaranes: "Convertir albaranes",
    cancelarConversion: "Cancelar conversión",
    convertir: "Convertir",
    convertirAlbaranEnFactura: "Convertir albarán en factura",
    refFactura: "Ref factura",
    albaranesDeLaFactura: "Albaranes de la factura",
    finalizada: "finalizada",
    conversion: "Conversión",
    error: "Error",
    estaSeguroDeVerificarEsteGasto: "¿Está seguro de verificar este gasto?",
    siVerficarGasto: "Sí, verificar gasto",
    estasSeguroDeEliminarElGasto: "¿Estás seguro de eliminar el gasto?",
    siEliminarGasto: "Sí, eliminar gasto",
    contabilizadoCambiadoCorrectamente: "Contabilizado cambiado correctamente",
    gastoEliminadoCorrectamente: "Gasto eliminado correctamente",
    hacerInventario: "Hacer inventario",
    seleccionarTodas: "Seleccionar Todas",
    inventarioRealizadoCorrectamente: "Inventario realizado correctamente",
    traspaso: "Traspaso",
    negocioDeDestino: "Negocio de destino",
    referenciaNecesaria: "Referencia necesaria",
    elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos: "El movimiento de almacén tiene que tener asignado un producto o productos",
    realizado: "realizado",
    buscarSinPuntos: "Buscar",
    enviarInventario: "Enviar inventario",
    volverAlAlmacen: "Volver al almacén",
    inventarioCompletado: "Inventario completado",
    inventarioNoEncontrado: "Inventario no encontrado",
    cargandoInventario: "Cargando inventario",
    importacion: "Importación",
    importar: "Importar",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tienes que seleccionar un archivo de importación",
    importandoVentasDelNegocio: "Importando ventas del negocio...",
    nuevosProductos: "Nuevos Productos",
    seHanCreadoLosSiguientesProductos: "Se han creado los siguientes productos",
    importandoMovimientosDeAlmacen: "Importando movimientos de almacén...",
    importandoDatos: "Importando datos...",
    tienesQueSeleccionarUnArchivoDeImportacion: "Tienes que seleccionar un archivo de importación",
    seleccionaCasa: "Selecciona casa...",
    desgloseDeVentasPorProductos: "Desglose de ventas por productos",
    noTienesPermisoParaVisualizarEsteInforme: "No tienes permiso para visualizar este informe",
    historicoVentasPorCliente: "Histórico ventas por cliente",
    buscarPorNombreDelCliente: "Buscar por nombre del cliente",
    importeSinDto: "Importe sin Dto.",
    nTickets: "Nº Tickets",
    seleccioneUnClienteValido: "Seleccione un cliente válido",
    seleccioneUnNegocioParaVerLosTickets: "Seleccione un negocio para ver los tickets",
    ventasDeCategoriasPorClientes: "Ventas de categorías por clientes",
    desgloseDeVentasDeLaCategoria: "Desglose de ventas de la categoría",
    verImporteEnCategoriasHijas: "Ver importe en categorias hijas",
    gestionDePedidos: "Gestión de pedidos",
    cargandoGastos: "Cargando gastos...",
    tiempoMedioCocina: "Tiempo medio cocina",
    nComandas: "Nº Comandas",
    eliminada: "eliminada",
    tiempoMedio: "Tiempo medio",
    noHayComandasEnviadasAlKdsEnEsteRangoDeFechas: "No hay comandas enviadas al kds en este rango de fechas",
    tiempoMedioProducto: "Tiempo medio producto",
    nProductos: "Nº Productos",
    informePersonalizado: "Informe Personalizado",
    nombreDelDispositivo: "Nombre del dispositivo",
    dispositivo: "Dispositivo",
    registrosHorarios: "Registros horarios",
    marshallEjecutadoCorrectamente: "Marshall ejecutado correctamente",
    mes: "Mes",
    seleccionaUnaSemana: "Selecciona una semana",
    seleccioneUnaFechaValida: "Seleccione una fecha válida",
    noMayuscula: "NO",
    siMayuscula: "SI",
    editarObservacion: "Editar observación",
    anadirObservacion: "Añadir observación",
    editarHoraInicioYHoraFin: "Editar hora inicio y hora fin",
    editarHorario: "Editar horario",
    editarHorarioDeTurno: "Editar horario de turno",
    observacion: "Observación",
    turnosOperarios: "Turnos operarios",
    compartirEnlaceTurnos: "Compartir enlace de turnos",
    enlaceGeneradoExito:"Enlace generado correctamente",
    enlaceCopiadoAlPortapapeles:"Enlace copiado al portapapeles",
    enlaceExternoTurnosTitle: "Enlace externo para consulta de turnos",
    enlaceExternoTurnosLabel: "A través de este enlace podrás consultar los turnos de los operarios. Caducará en 24 horas.",
    errorComunicacionBackend: "Error de comunicación con el servidor.",
    errorNoSeHaPodidoGenerarElEnlace: "Lo sentimos, no se ha podido generar el enlace, inténtalo de nuevo",
    enlaceExternoTurnosOperariosTitle: "Turnos de operarios de ",
    enlaceExternoTurnosCaducadoTitle: "El enlace ha caducado",
    enlaceExternoTurnosCaducadoLabel: "Para consultar los turnos de los operarios, contacte con el administrador del negocio para que vuelva a generar un nuevo enlace.",
    ventasDeProductosMinusculas: "ventas de productos",
    pedidosGuionPasarelaDePago: "Pedidos - Pasarela de Pago",
    numPedidos: "Num.Pedidos",
    costoPorPedido: "Costo por pedido",
    totalComisiones: "Total Comisiones",
    totalSinComisiones: "Total sin comisiones",
    errorEnLaPeticion: "Error en la petición",
    rentabilidad: "Rentabilidad",
    buscarPorNombreDelRepartidor: "Buscar por nombre del repartidor",
    verDesgloseDeTarifas: "Ver Desglose de tarifas",
    ventasPorMeses: "Ventas por meses",
    ventasHoras: "Ventas horas",
    tarifasDelProducto: "Tarifas del producto",
    cantidad: "Cantidad",
    fechaDesde: "Fecha desde",
    fechaHasta: "Fecha hasta",
    seleccionaProcedencia: "Selecciona procedencia...",
    verDesgloseFacturas: "Ver desglose facturas",
    verDesgloseMateriasPrimas: "Ver desglose materias primas",
    seleccionaUnaEtiqueta: "Selecciona una etiqueta",
    buscarPorNombreDeLaMateriaPrima: "Buscar por nombre de la materia prima",
    ventasDeMateriasPrimas: "Ventas de materias primas",
    seleccionaTpv: "Selecciona TPV...",
    deVentas: "de ventas",
    totalComision: "Total comisión",
    totalSinComision: "Total sin comisión",
    desgloseFacturas: "Desglose facturas",
    facturasDelProveedor: "Facturas del proveedor",
    retiradas: "Retiradas",
    buscarTicket: "Buscar ticket...",
    baseMayusculas: "BASE",
    numServ: "Num. Serv.",
    ticketMed: "Ticket Med.",
    necesitasElegirUnTpvParaPoderVerLosDetallesDeEste: "Necesitas elegir un TPV para poder ver los detalles de este",
    ventasMinusculas: "ventas",
    totales: "Totales",
    noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha: "No tienes ningun rango de fecha creado. ¿Deseas crear un rango de fecha?",
    siCrearUnRangoHorario: "Sí, crear un rango horario",
    detalleDe: "Detalle de ",
    cierresDeCaja: "cierres de caja",
    ventasNegocioPorZonaHoraria: "Ventas negocio por zona horaria",
    porZonaHoraria: " por zona horaria",
    detalleDeVentasSegun: "Detalle de ventas según",
    comensalesMinuscula: " comensales",
    desgloseDe: "Desglose de ",
    ticketsCobrados: "tickets cobrados",
    segunTipoDeIVA: "según tipo de IVA",
    facturasEmitidas: "Facturas emitidas",
    aClientes: " a clientes",
    desgloseDeVentasSegun: "Desglose de ventas según ",
    formasDePagoMinusculas: "formas de pago",
    agenciasMinusculas: "agencias",
    cuentasACredito: "cuentas a crédito",
    sumatorioDe: "Sumatorio de ",
    impuestos: "impuestos",
    porFechas: " por fechas",
    cuentasAnuladasMinusculas: "cuentas anuladas",
    delNegocio: " del negocio",
    cuentasRectificadas: "Facturas rectificativas",
    cuentasRectificadasMinusculas: "facturas rectificativas",
    retiradasMinusculas: "retiradas",
    ventaDeProductosPorNegocio: "Ventas de productos por negocio",
    rankingDe: "Ranking de",
    costeDeProductos: "Coste de productos",
    margenDeCostes: "Margen de costes",
    segunVentasPorRangoDeFecha: "según ventas por rango de fecha",
    historicoDeProducto: "Historico de producto",
    rankingAgrupadoDe: "Ranking agrupado de",
    enTodosLosNegocios: "en todos los negocios",
    ventasDeCategoriasPorNegocio: "Ventas de categorías por negocio",
    agrupacionDe: "Agrupación de",
    ventasDeCategoriasMinusculas: "ventas de categorías minúsculas",
    deProductos: "de productos",
    invitacionesMinusculas: "invitaciones",
    ventasPorMateriasPrimas: "Ventas por materias primas",
    ventasDeMateriasPrimasMinusculas: "ventas de materias primas",
    comprasDeMateriasPrimas: "compras de materias primas",
    porRangoDeFecha: "por rango de fecha",
    comprasAProveedores: "compras a proveedores",
    comprasAUnProveedor: "compras a un proveedor",
    porRangoDeFechaEn: "por rango de fecha en",
    todosLosNegocios: "todos los negocios",
    comprasAgrupadasPorEtiquetas: "compras agrupadas por etiquetas",
    comprasAFabricantes: "compras a fabricantes",
    comprasAUnFabricante: "compras a un fabricante",
    ranking: "Ranking",
    detallesDe: "Detalles de",
    turnos: "turnos",
    ventasPorClientesPlural: "Ventas por cliente",
    deVentasPorClientes: "de ventas por cliente",
    consultaDeVentasPorCliente: "Consulta de ventas por cliente",
    historico: "Histórico",
    deVentasPorCliente: "de ventas por cliente",
    numierPedidos: "Numier Pedidos",
    informeDePasarelaDePago: "Informe de Pasarela de Pago",
    desgloseDiarioDeLosPagosATraves: "Desglose diario de los pagos a través",
    pasarelaDePagoStripe: "Pasarela de pago Stripe",
    clicParaMasInformacion: "Clic para más información",
    cantidadMinusculas: "cantidad",
    totalMinusculas: "total",
    tarjetaYCheques: "Tarjeta y cheques",
    seleccionaOperario: "Selecciona operario...",
    necesitasSeleccionarUnProveedorParaPoderHacerUnPedido: "Necesitas seleccionar un proveedor para poder hacer un pedido",
    estePedidoNoEsValido: "Este pedido no es válido",
    quieresRestablecerElPedido: "¿Quieres restablecer el pedido?",
    siRestablecerPedido: "Sí, restablecer pedido",
    datosPersonales: "Datos Personales",
    datosDeAcceso: "Datos de Acceso",
    contrasenaAntigua: "Contraseña Antigua",
    contrasenaNueva: "Contraseña Nueva",
    confirmarContrasena: "Confirmar Contraseña",
    quieresDarDeAltaUnUsuario: "¿Quieres dar de alta un usuario?",
    quieresDarDeBajaUnUsuario: "¿Quieres dar de baja un usuario?",
    licencias: "Licencias",
    fechaCaducidad: "Fecha caducidad",
    ilimitado: "ILIMITADO",
    lasContrasenasNoCoinciden: "Las contraseñas no coinciden",
    seleccionaUsuario: "Selecciona usuario...",
    usuario: "Usuario",
    negocios: "Negocios",
    balance: "Balance",
    teHaParecidoUtilEsteArticulo: "¿Te ha parecido útil este artículo?",
    graciasPorTuOpinion: "Gracias por tu opinión",
    asignarTurno: "Asignar turno",
    vacaciones: "Vacaciones",
    descargarPDF: "Descargar PDF",
    enviarHorario: "Enviar Horario",
    incidenciasEnElMes: "incidencias en el mes",
    diasDeVacacionesEnElMes: "días de vacaciones en el mes",
    diasDeVacacionesEnElAno: "días de vacaciones en el año",
    nuevoTurno: "Nuevo turno",
    clonarTurno: "Clonar turno",
    nombreDelTurno: "Nombre del turno",
    diasDeLaSemana: "Días de la semana",
    editarTurno: "Editar turno",
    borrarTurno: "Borrar turno",
    evento: "Evento",
    nombreEvento: "Nombre evento",
    hayUnaIncidenciaEnEsteTurno: "Hay una incidencia en este turno",
    fechaInicioTurno: "Fecha inicio turno",
    fechaFinTurno: "Fecha fin turno",
    numHorasTurno: "Nº horas turno",
    fechaInicioTrabajada: "Fecha inicio trabajada",
    fechaFinTrabajada: "Fecha fin trabajada",
    numHorasTrabajadas: "Nº horas trabajadas",
    noIniciado: "No iniciado",
    noFinalizado: "No finalizado",
    fechaInicioVacaciones: "Fecha inicio vacaciones",
    fechaFinVacaciones: "Fecha fin vacaciones",
    turnoHorario: "Turno horario",
    nombreTurno: "Nombre turno",
    campoRequerido: "Campo requerido",
    introduzcaLosDiasDeLaSemana: "Introduzca los días de la semana",
    crearTurnoHorarioDeOperario: "Crear turno horario de operario",
    introduzcaLosOperarios: "Introduzca los operarios",
    laboral: "Laboral",
    vacacional: "Vacacional",
    seleccionaTurno: "Selecciona turno...",
    seleccionaLosNegociosALosQueQuiereClonarElTurno: "Selecciona los negocios a los que quiere clonar el turno",
    seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios: "Selecciona la fecha en la que deseas copiar los horarios",
    seleccioneUnaSemana: "Seleccione una semana",
    lunes: "Lunes",
    martes: "Martes",
    miercoles: "Miércoles",
    jueves: "Jueves",
    viernes: "Viernes",
    sabado: "Sábado",
    domingo: "Domingo",
    laFechaSeleccionadaNoEsValida: "La fecha seleccionada no es válida",
    turnoClonadoCorrectamente: "Turno clonado correctamente",
    correoEnviadoCorrectamente: "Correo enviado correctamente",
    estasSeguroDeBorrarElTurnoSeleccionado: "¿Estás seguro de borrar el turno seleccionado",
    siBorrarTurno: "Sí, borrar turno",
    necesitasCrearAlgunTurnoParaPoderCrearCuadrantes: "Necesitas crear algún turno para poder crear cuadrantes",
    estasSeguroDeEditarElTurno: "¿Estás seguro de editar el turno?",
    siEditarTurno: "Sí, editar turno",
    hoy: "Hoy",
    turno: "Turno",
    turnoBorradoCorrectamente: "Turno borrado correctamente",
    informacion: "Información",
    elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido: "El día no corresponde con la configuración del turno elegido",
    turnoCopiadoCorrectamente: "Turno copiado correctamente",
    turnoDeOperarioAgregadoCorrectamente: "Turno de operario agregado correctamente",
    turnoDeOperarioEliminadoCorrectamente: "Turno de operario eliminado correctamente",
    turnoDeOperarioEditadoCorrectamente: "Turno de operario editado correctamente",
    tecnicoConsultasTecnicasIncidencias: "Técnico (Consultas técnicas, Incidencias...)",
    comercialActivacionDeProductosInformacionServicios: "Comercial (Activación de productos, Información, Servicios...)",
    administracionFacturacionReclamaciones: "Administración (Facturación, Reclamaciones...)",
    elAsuntoEsObligatorio: "El asunto es obligatorio",
    elMensajeEsObligatorio: "El mensaje es obligatorio",
    soporteOnlineEnviadoCorrectamente: "SoporteOnline enviado correctamente",
    todosLosNegociosMayusculas: "Todos los negocios",
    recordarMisDatos: "Recordar mis datos",
    paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros: "Para cualquier incidencia o más información puede ponerse en contacto con nosotros",
    iniciarSesion: "Iniciar sesión",
    haOlvidadoSuContrasena: "¿Ha olvidado su contraseña?",
    haHabidoUnErrorAlConectarPruebeDeNuevo: "Ha habido un error al conectar. Pruebe de nuevo",
    elEmailNoPuedeEstarEnBlanco: "El email no puede estar en blanco",
    elEmailNoEsValido: "El email no es válido",
    laContrasenaNoPuedeEstarEnBlanco: "La contraseña no puede estar en blanco",
    estaPaginaNoSeEncuentraEnElSistema: "Esta página no se encuentra en el sistema",
    volverAlInicio: "Volver a inicio",
    obtenerContrasena: "Obtener contraseña",
    disculpeLasMolestiasEstamosDeMantenimiento: "Disculpe las molestias, estamos de mantenimiento",
    vuelvaAIntentarloMasTarde: "Vuelva a intentarlo más tarde",
    acepto: "Acepto",
    categoriasDeClientes: "Categorías de clientes",
    categoriaDeCliente: "categoría de cliente",
    nombreCategoria: "Nombre categoría",
    noSeleccionada: "No seleccionada",
    cobradoMayusculas: "COBRADO",
    envioProgramadoPara: "Envío programado para",
    eliminarPedido: "Eliminar pedido",
    aceptarPedido: "Aceptar pedido",
    pedidoConfirmado: "Pedido confirmado",
    archivarPedido: "Archivar pedido",
    detallesPedido: "Detalles pedido",
    nota: "Nota",
    precioUd: "Precio Ud",
    gratis: "GRATIS",
    guardarYAceptarPedido: "Guardar y aceptar pedido",
    seleccionaGrupo: "Selecciona grupo...",
    todosMayusculas: "TODOS",
    nombreOperario: "Nombre operario",
    apellidos: "Apellidos",
    claveAcceso: "Clave acceso",
    codigoDeTurnos: "Código de turnos",
    claveAccesoPDA: "Clave acceso PDA",
    seleccionaIVA: "Selecciona IVA",
    calcularCostoAPartirDeMateriasPrimas: "Calcular costo a partir de materias primas",
    seleccionaImpresoraDeComandasTPV: "Selecciona impresora de comandas TPV",
    seleccionaImpresoraDeComandasPDA: "Selecciona impresora de comandas PDA",
    buscarMateriaPrima: "Buscar materia prima",
    nuevaMateriaPrima: "Nueva materia prima",
    ordenarSubproductos: "Ordenar subproductos",
    seleccionaEtiqueta: "Selecciona etiqueta...",
    clonarProducto: "Clonar producto",
    clonarProductoCarta: "Clonar producto",
    buscarSinPuntos: "Buscar",
    noPuedeHaberDosMateriasPrimasConElMismoTipo: 'No puede haber dos materias primas con el mismo tipo',
    sinProveedores: "Sin proveedores",
    agregadas: "agregadas",
    modificadas: "modificadas",
    materiaPrimaEliminadaCorrectamente: "Materia prima eliminada correctamente",
    asociacion: "asociación",
    materiaPrimaOrdenadaCorrectamente: "Materia prima ordenada correctamente",
    productosCopiadosCorrectamente: "Productos copiados correctamente",
    menuCopiadoCorrectamente: "Menú copiado correctamente",
    responder: "Responder",
    cliente: "Cliente",
    administracion: "Administración",
    soporteTecnico: "Soporte técnico",
    horaInicioMayusculas: "Hora Inicio",
    horaFinal: "Hora Final",
    personaDeContacto: "Persona de contacto",
    motivoVisita: "Motivo visita",
    servicioBajoMantenimiento: "Servicio bajo mantenimiento",
    desplazamiento: "Desplazamiento",
    ticketEnviadoCorrectamente: "Ticket enviado correctamente",
    precioCompraConDescuento: "Precio compra con descuento",
    introduzcaLasPartesDelStockMinimo: "Introduzca las partes del stock mínimo",
    actualizarStockMinimoYOptimo: "Actualizar stock mínimo y óptimo",
    subproductoDeVerdad: "Subproducto",
    entregado: "Entregado",
    retirada: "Retirada",
    subtotal: "Subtotal",
    pagosACuenta: "Pagos a cuenta",
    horaDeApertura: "Hora de apertura",
    horaInicio: "Hora inicio",

    condicionesDeNumierOnline: "Condiciones de Numier Online",
    descripcionDelServicio: "Descripcion del Servicio",
    terminosIntroduccionParte1: "El servicio en la nube de Numier ofrecido por NEXODO DIGITAL S.L. (apartir de ahora NEXODO), facilita a sus clientes el acceso online a la información actualizada de sus negocios.",
    terminosIntroduccionParte2: "Para ello, las aplicaciones de punto de venta de Numier enviarán a través de internet detalles de las ventas realizadas y otro tipo de información que pueda ser interesante para sus clientes.",
    terminosIntroduccionParte3: "El acceso a este servicio se realizará a través de la página web https://www.numier.com/clientes, donde podrá consultar la información enviada por sus puntos de venta.",
    terminosIntroduccionParte4: "NEXODO reserva el derecho de mejorar, modificar o anular el servicio en cualquier momento.",
    politicaDePrivacidad: "Política de privacidad",
    privacidadParte1: "1. NEXODO ha realizado la siguiente declaración de privacidad con el objetivo de manifestar su firme propósito de proteger su privacidad. NEXODO le ruega que lea atentamente esta política de privacidad antes de utilizar este servicio ya que ello implica que NEXODO recopile y procese sus datos personales de acuerdo a esta política. NEXODO se reserva el derecho a modificar en cualquier momento la política de privacidad. En ese caso NEXODO se compromete a ponerse en contacto con usted para informarle de las modificaciones que le afecten.",
    privacidadParte2: "2. NEXODO respeta sus opciones de privacidad. En el caso de que nos proporcione alguna información se tratará de acuerdo a esta política.",
    privacidadParte3: "3. NEXODO le recomienda discreción a la hora de proporcionar información a operadores o propietarios del sitio. Es importante que tenga en cuenta que proporcionar información personal en lugares de acceso público, como salas de chat implica que cualquier persona con acceso a internet pueda disponer de su información. Le recomendamos que no introduzca ninguna información que no desee que otros puedan ver en estas zonas públicas.",
    privacidadParte4: "4. Si decide registrarse en NUMIER ONLINE es posible que deba aportar datos personales. Es importante que registre correctamente la información en la fecha de registro. Si su información personal cambia tras haber efectuado el registro deberá cambiarla o actualizarla inmediatamente. De no hacerlo es posible que no reciba algún servicio o información de NEXODO.",
    privacidadParte5: "5. NEXODO puede utilizar su información personal con la finalidad de realizar mejoras en este sitio.",
    privacidadParte6: "6. NEXODO recopila estos datos con la finalidad de obtener información para mejorar sus servicios y sus productos. Y es posible que utilicemos la información que nos ha proporcionado para enviarle ofertas por correo electrónico o postal que puedan ser de su interés.",
    privacidadParte7: "7. Para anular su suscripción a dichos correos deberá ponerse en contacto con NEXODO para informar de su decisión. De otro modo NEXODO mantendrá la información del usuario hasta el momento en que la suscripción sea anulada o hasta el vencimiento de cualquier período necesario descrito en la normativa vigente.",
    privacidadParte8: "8. NEXODO no revelará sus datos a ningún tercero sin su consentimiento, a menos que pensemos de buena fe que la ley lo requiere.",
    privacidadParte9: "9. Tiene la posibilidad de anular la totalidad de los datos de su suscripción que figuren en nuestra base de datos. Para ello deberá ponerse en contacto con la empresa y realizar su solicitud.",
    privacidadParte10: "10. 10. NEXODO ha tomado medidas para garantizar que la información sólo estará disponible para el usuario que introdujo la información en un principio. ",
    privacidadParte11: "11. Sólo se puede acceder a la información una vez se haya introducido la contraseña.",
    privacidadParte12: "12. Este sitio puede contener enlaces a otros sitios que no están asociados con NEXODO. Estos sitios tienen sus propias políticas de privacidad de las que NEXODO no se hace responsable. El acceso a estos sitios vinculados se realiza bajo su exclusiva responsabilidad.",
    privacidadParte13: "13. NEXODO garantiza la seguridad de la información referente a sus usuarios exceptuando los casos que se describen a continuación:",
    privacidadParte13dos: "- Si NEXODO dispone de su consentimiento.",
    privacidadParte13tres: "- Si se insta a NEXODO a proporcionar dicha información por indicación legal, requerimiento judicial u otro procedimiento jurídico.",
    privacidadParte13cuatro: "- Si la revelación de estos datos es necesaria para proteger los derechos y la propiedad de NEXODO.",
    privacidadParte13cinco: "- Si la revelación de información de sus datos es necesaria para mejorar los servicios y productos de nuestros clientes, incluido usted.",
    privacidadParte14: "14. NEXODO garantiza el mantenimiento adecuado de su información en un servidor seguro y encriptado al que sólo puedan acceder terceros autorizados. ",

    cartaDigital: "Carta digital",
    horarios: "Horarios",
    zonas: "Zonas",
    modificarHorariosDeLaCarta: "Modificar horarios de la carta",
    modificarZonasDeLaCarta: "Modificar zonas de la carta",
    diaDeLaSemana: "Día de la semana",
    esteNegocioNoTieneCarta: "Este negocio no tiene carta",
    tipoDeEnvio: "Tipo de envío",
    nuevoHorario: "Nuevo horario",
    elCampoDiaDeLaSemanaEsRequerido: "El campo día de la semana es requerido",
    borrarHorario: "Borrar horario",
    laHoraInicioNoPuedeSerMayorQueLaHoraFin: "La hora inicio no puede ser mayor que la hora fin",
    noHayHorariosEnEsteNegocio: "No hay horarios en este negocio",
    deseaEliminarEsteHorario: "¿Desea eliminar este horario?",
    siBorrarHorario: "Sí, borrar horario",
    seleccioneDiaDeLaSemana: "Seleccione día de la semana",
    seleccioneTipoDeEnvio: "Selecciones tipo de envío",

    //NUEVO
    importacionSage: "Importación Sage",
    importacionContable: "Importación contable",
    enlaceContable: "Enlace contable",
    ejercicio: "Ejercicio",
    codigoEmpresa: "Codigo Empresa",
    asiento: "Asiento",
    cargoAbono: "Cargo Abono",
    codigoCuenta: "Codigo Cuenta",
    fechaAsiento: "Fecha Asiento",
    comentario: "Comentario",
    importeAsiento: "Importe Asiento",
    numeroPeriodo: "Número Periodo",
    delegacion: "Delegación",
    canal: "Canal",
    ejercicioFactura: "Ejercicio Factura",
    serie: "Serie",
    factura: "Factura",
    suFacturaNo: "Su Factura No",
    fechaFactura: "Fecha Factura",
    importeFactura: "Importe Factura",
    tipoFactura: "Tipo Factura",
    codigoCuentaFactura: "Código Cuenta Factura",
    codigoRetencion: "Código Retención",
    baseRetencion: "Base Retención",
    porRetencion: "Por Retención",
    importeRetención: "Importe Retención",
    baselva1: "Baselva 1",
    porlva1: "Porlva 1",
    cuotaIva1: "Cuota IVA 1",
    porRecargoEquivalencia1: "Por Recargo Equivalencia 1",
    recargoEquivalencia1: "Recargo Equivalencia 1",
    codigoTransaccion1: "Código Transacción 1",
    descargarComoTxt: "Descargar como .txt",

    noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha: "No hay asientos contables en este tpv con este rango de fecha",
    cargandoAsientosContables: "Cargando asientos contables",
    fechaDeAperturaDeCaja: "Fecha de apertura de caja",
    fechaDeCierreDeCaja: "Fecha de cierre de caja",
    descargarVentas: "Descargar ventas",
    descargarGastos: "Descargar gastos",
    noHasCerradoEstaCaja: "No has cerrado esta caja",
    numeroDeCierres: "Número de cierres",
    introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE: "Introduzca el ultimo número de asiento contable que tiene en SAGE",
    porFavorRelleneElAsientoContable: "Por favor, rellene el asiento contable",
    descargar: "Descargar",
    elAsientoContableDebeSerUnNumero: "El asiento contable debe ser un número",
    elAsientoContableNoPuedeSerMayorA10Digitos: "El asiento contable no puede ser mayor a 10 dígitos",
    TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos: "Tenga en cuenta que utilizaremos los siguientes números a este para completar los datos",
    noExistenVentasEsteDia: "No existen ventas este día",
    noExistenGastosEsteDia: "No existen gastos este día",
    enSage: "en SAGE",
    proyecto: "Proyecto",
    codigoEmpresaHelp: "Recuerda que el dato empresa se comparte entre todos los negocios de la misma empresa",
    cuentasDelTpvSeleccionado: "Cuentas del TPV seleccionado",
    nuevaCuenta: "Nueva cuenta",
    nombreDeCuenta: "Nombre de cuenta",
    codigoCuentaMinuscula: "Código cuenta",
    tipoDeCuenta: "Tipo de cuenta",
    noHayCuentasCreadasConElTpvSeleccionado: "No hay cuentas creadas con el TPV seleccionado",
    crearNuevaCuenta: "Crear nueva cuenta",
    codigoDeLaCuenta: "Código de la cuenta",
    codigoDeLaSubcuenta: "Código de la sub cuenta",
    configuracionCuentasIva: "Configuración cuentas IVA",
    configuracionCuentasEspeciales: "Configuración cuentas especiales",
    cuenta: "Cuenta",
    subcuenta: "Sub cuenta",
    editarCuenta: "Editar cuenta",
    tipo: "Tipo",
    sage200: "SAGE 200",
    exportarCAPTE: "Exportar CAPTE",
    losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos: "Los campos nombre, código de cuenta y código de subcuenta deben estar rellenos",
    estaSeguroDeQueDeseaEliminarEstaCuenta: "¿Está seguro de que desea eliminar esta cuenta?",
    siBorrarCuenta: "Sí, borrar cuenta",
    cuentaEditadaCorrectamente: "Cuenta editada correctamente",
    cuentaCreadaCorrectamente: "Cuenta creada correctamente",
    configuracionSAGE: "Configuración Sage",
    sinCuentaAsociada: "Sin cuenta asociada",
    loSientoSuNegocioNoTieneContratadoSAGE: "Lo sentimos, su negocio no tiene contratado SAGE",
    loSientoSuNegocioNoTieneContratadoEsteModulo: "Lo sentimos, su negocio no tiene contratado este módulo",
    paraMasInformacionContacteConComerciales: "Para más información contacte con comerciales",
    laLongitudMaximaDeLasSubCuentas: "La longitud máxima de la sub cuenta tiene que ser de 12 caracteres",

    //NUEVOS
    preparados: "Preparados",
    enReparto: "En reparto",
    noHayPedidosPreparados: "No hay pedidos preparados",
    noHayPedidosEnReparto: "No hay pedidos en reparto",
    pedidoListo: "Pedido listo",
    pedidoEnReparto: "Pedido en reparto",

    codigo: "Código",
    crearNuevoCodigoCuenta: "Crear nuevo código cuenta",
    editarNuevoCodigoCuenta: "Editar nuevo código cuenta",
    seleccioneUnaFormaDePagoParaElGasto: "Seleccione una forma de pago para el gasto",
    hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna: "Has seleccionado albaranes con diferentes formas de pago, por favor seleccione una",
    seleccioneUnaFormaDePago: "Seleccione una forma de pago",
    zonasActualizadasCorrectamente: "Zonas actualizadas correctamente",
    zonaCreadaCorrectamente: "Zona creada correctamente",
    zonaEditadaCorrectamente: "Zona editada correctamente",
    guardarCambios: "Guardar cambios",
    laZonaNoPuedeTenerElNombreEnBlanco: "La zona no puede tener el nombre en blanco",
    zonasDeReparto: "Zonas de reparto",
    editarZona: "Editar zona",
    color: "Color",
    costeDeReparto: "Coste de reparto",
    pedidoMinimo: "Pedido mínimo",
    crearNuevaZona: "Crear nueva zona",
    estasSeguroDeQueQuieresEliminarLaZona: "¿Estás seguro de que quieres eliminar la zona?",
    estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos: "Esta zona dejará de estar disponible inmediatamente y no se harán pedidos desde la misma",
    siEliminarZona: "Sí, eliminar zona",
    zonaEliminadaCorrectamente: "Zona eliminada correctamente",
    ventasExportadas: "Ventas exportadas",
    gastosExportados: "Gastos exportados",
    todosLosCierresDeEsteDiaHanSidoExportados: "Todos los cierres de este día han sido exportados",
    faltanVentasPorExportarEsteDia: "Faltan ventas por exportar este día",
    todosLosGastosDeEsteDiaHanSidoExportados: "Todos los gastos de este día han sido exportados",
    faltanGastosPorExportarEsteDia: "Faltan gastos por exportar este día",
    exportar: "Exportar",
    /*this.$i18n.t("productos"))*/

    /*"$i18n.t('editar')*/

    //10-02-2021
    otros: 'Otros',
    restriccionHorarios: 'Restricción Horarios',
    restriccionHorariosDesc: "Restringir algunas franjas horarias(cerrado, lleno, no reparto...)",
    borrar: 'Borrar',
    restriccion: "Restricción",
    nMaximoPedidos: "Nº Máximo de pedidos",
    cerrarFranja: "Cerrar franja",
    limitePedidos: "Límite Nº Pedidos",
    loSentimosSuNegocioNoTieneContratadoEsteModulo: "Lo sentimos, su negocio no tiene contratado este módulo",
    numeroPedidosPermitidos: "Número de pedidos permitidos",
    estaSeguroDeQueDeseaEliminarEstaRestriccion: "¿Está seguro de que desea eliminar esta restricción?",
    siBorrarRestriccion: "Sí, borrar restricción",
    loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion: "Lo sentimos, para acceder a este módulo necesita activar la configuración",
    costeSinIVA: "Coste sin IVA",

    //11.3.2021
    importeIVA: "Importe IVA",

    //17.3.2021
    pasarAPreparacion: "Pasar a preparación",
    pasarAPreparados: "Pasar a preparados",
    pasarAEnReparto: "Pasar a en reparto",
    finalizarPedido: "Finalizar pedido",
    //Tener en cuidado con los espacios, ya que son los espacios Braille
    domicilioActivado: "‏‏‎DOMICILIO⠀ACTIVADO",
    domicilioDesactivado: "DOMICILIO⠀DESACTIVADO",
    recogerActivado: "RECOGER⠀ACTIVADO",
    recogerDesactivado: "RECOGER⠀DESACTIVADO",
    //
    conDetalles: "con detalles",
    zonasRepartoActivadas: 'ACTIVADAS⠀',
    zonasRepartoDesactivadas: 'DESACTIVADAS⠀',
    siEliminarCategoria: "Sí, eliminar categoría",
    confirmaEliminarCategoria: "¿Está seguro de que quiere eliminar esta categoría?",
    pedidoPreparado: "Pedido preparado",
    configuracionParaLaImportacionExportacionDeDatosDeSage: "Configuración para la importación/exportación de datos de Sage",
    enEstaPantallaSeConfiguranLosCodigosDeLasCuentas: "En esta pantalla se configuran los códigos de las cuentas",
    formadosPor3Digitos: 'formados por 3 dígitos',
    estosSonNecesariosParaConfigurarLasCuentasContables: "Estos son necesarios para configurar las cuentas contables",
    alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente: "Al editar un código relacionado con una cuenta contable ya existente",
    todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta: "todo cambio que se produzca sobre este afectará también a la propia cuenta",
    aContinuacionSeListaranLasCuentasDeTipo: "A continuación se listarán las cuentas de tipo",
    gastoMinuscula: "gasto",
    paraQue: "para que",
    asocieMinuscula: "asocie",
    ventaMinuscula: "venta",
    unaParaSuPosterior: "una para su posterior",
    relacionEnSage: "relación en SAGE",
    relacionEnContabilidad: "relación en contabilidad",
    seleccioneUnaCuenta: "Seleccione una cuenta",
    aDomicilio: "A domicilio",
    aRecoger: "A recoger",
    tipoDeZona: "Tipo de zona",
    seleccioneUnTipo: "Seleccione un tipo",
    kilometrosDelArea: "Kms del área",
    codigoEmpleado: "Codigo empleado",
    exportarReservas: "Exportar reservas",
    importacionSinqro: "Importación Sinqro",
    configuracionParaLaImportacionDeDatosDeSinqro: "Configuración para la importación de datos de Sinqro",
    pasarelaDePago: "Pasarela de pago",
    importeSinDescuento: "Importe sin descuento",
    desactivarZona: "Desactivar zona",
    activa: "ACTIVA",
    inactiva: "INACTIVA",
    exportarPdfConMateriasPrimasAsociadas: "Exportar PDF con materias primas asociadas",
    exportarExcelConMateriasPrimasAsociadas: "Exportar Excel con materias primas asociadas",

    //Pedidos archivados 18/05/21
    informePedidosDetalle: "Desglose de pedidos",
    informePedidos: "Informe de pedidos",
    tipoPago: "Forma de pago",
    tipoPedido: "Tipo de pedido",
    domicilio: "Envio a domicilio",
    recoger: "Recogida en local",
    pagoLocal: "Pago en local",
    otro: "Otro",

    //25/05/2021
    configuracionTurnos: "Configuración turnos",

    //2021/05/20
    estasSeguroDeImportarTusProductosASinqro: "¿Desea importar sus productos a Sinqro?",
    esteProcesoPuedeTardarVariosMinutos: "Este proceso puede tardar varios minutos.",
    siImportarConSinqro: "Sí, importar a Sinqro",
    estasSeguroDeDarDeBajaElProducto: "¿Desea dar de baja el producto?",
    podraDarloDeAltaEnUnFuturo: "Podrá darlo de alta en un futuro",
    siDarDeBaja: "Sí, dar de baja",
    estasSeguroDeDarDeAltaElProducto: "¿Desea dar de alta el producto?",
    podraDarloDeBajaEnUnFuturo: "Podrá darlo de baja en un futuro.",
    siDarDeAlta: "Sí, dar de alta",
    laImportacionTardara: "Importando... este proceso puede tardar varios minutos",
    importacionFinalizada: "Importación completada con exito",
    completo: "Completado",
    vale: "Vale",
    importarSinqro: "Importar Sinqro",
    importandoProductos: "La importación se está llevando a cabo en estos momentos...",
    generandoCarta: "Este es el último paso... Estamos generando su carta.",
    procesoFin: "El proceso se ha completado con éxito",
    procesoCompletado: "Proceso completado",
    yaFaltaPoco: "Ya falta poco...",
    estamosEnEllo: "Estamos trabajando en la importacion. Por favor, no recargue el navegador. ",
    finProgres: "El progreso terminó con exito.",
    textoInfo: "Esta columna muestra el precio de compra sin IVA",
    textoInfoImporteDTO: "Esta columna muestra el precio total de compra con descuento (el cual se calcula a partir del precio sin IVA)",
    correosEnviados: "Correos enviados",
    correosEnviadosCorrectamente: "Los correos se enviaron correctamente.",
    errorAlEnviar: "Error al enviar",
    noSePudieronEnviarTodosLosCorreos: "No se pudieron enviar todos los correos:",
    errorInesperadoEnvioCorreos: "Ocurrió un error inesperado. Por favor, inténtelo de nuevo más tarde",

    //07/06/2021
    valorRecuento: "Valor Recuento",

    //08/06/2021
    obligatorioEmail: "Obligatorio rellenar email",
    datosCliente: "Datos cliente",

    //11/06/2021
    recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres: "Recuerde que el hacer cobros avanzados puede generar pequeños descuadres",
    yQue: "y que",
    losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva: "los descuentos de las ventas estan al 0% de IVA",

    //16/06/2021
    totalValoresNegativos: "Total Valores Negativos",
    solamenteSeTieneEnCuentaValoresPositivos: "Solamente se tiene en cuenta valores positivos",
    totalValoresDiferencia: "Total Valores Diferencia",
    totalValoresDiferenciaDto: "Total Valores Diferecia Dto.",
    valorDiferencia: "Valor diferencia",
    valorDifereciaDto: "Valor diferencia dto.",
    precioDto: "Precio Dto.",

    //24/06/2021
    exportarMateriasPrimasAsociadasAEsteProducto: "Exportar materias primas asociadas a este producto",
    sinIVA: "Sin IVA",
    errorAlIntentarObtenerLosTpvs: "Error al intentar obtener los TPVs",

    //01/07/2021
    deseaguardarelproductoencarta: "A continuación, se procederá a replicar los nombres y los precios de las tarifas que sean mayor a 0€, asi como el campo baja. Estos cambios afectarán a todos los productos de NumierPEDIDOS, que estén relacionados con este producto.", leidoyacepto: "¡Lo entiendo!",
    replicarencarta: "¿Estás seguro?",
    aceptarreplicarencarta: "Aceptar y replicar en Numier Pedidos",
    guardaryreplicar: "Guardar y replicar en Carta",

    //01/07/2021
    porRangosHorarios: " por rangos horarios",

    //22/07/2021
    recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal: "Recuerde que las líneas de descuento no se suman al total",

    //16/07/21
    destacado: "Destacado",
    sugerido: "Sugerido",
    //23/07/2021
    totalSinDescuento: "Total sin descuento",

    //MENÚS
    menus: "Menús",
    descripcionMenus: "Grupo de productos que se venden de forma conjunta",
    numeroDePlatos: "Número de platos que el cliente podrá elegir por cada plato:",
    platosTip1: "En esta pantalla se pueden crear los distintos platos que",
    platosTip2: "componen el menú para su posterior asignación con los productos.",
    productosPlatosTip: "En esta pantalla se pueden relacionar platos y productos para su posterior visualización en la carta.",
    plato: "Plato",
    platos: "Platos",
    primerPlato: "Primer plato",
    segundoPlato: "Segundo plato",
    tercerPlato: "Tercer plato",
    cuartoPlato: "Cuarto plato",
    quintoPlato: "Quinto plato",
    sextoPlato: "Sexto plato",
    seleccionaUnPlato: "Selecciona un plato",
    noPuedeDejarEnBlancoElNombreDeUnPlato: "No puede dejar en blanco el nombre de un plato",
    estaSeguroDeQueQuiereBorrarEstePlato: "¿Está seguro de que quiere borrar este plato?",
    seBorraranTodasLasAsociacionesDeProductosConElMismo: "Se borrarán todas las asociaciones de productos con el mismo",
    siEstoySeguro: "Sí, estoy seguro",
    estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado: "¿Está seguro de que quiere desvincular este producto del plato seleccionado?",
    dejaraDeFormarParteDelMenuDeFormaInstantanea: "Dejará de formar parte del menú de forma instantánea",
    noMostrarSuelto: "No mostrar suelto (sólo disponible en menús)",
    clonarMenu: "Clonar menú",
    //29/07/2021
    totalPedidosDevueltos: "Nº de devoluciones",
    totalImportesDevueltos: "Total importe devuelto",

    //06/08/2021
    NoMostrarRecargasSaldo: "No mostrar recargas de saldo",
    //10/08/2021
    noMostrarDescuento: "No mostrar descuentos",
    //17/08/2021
    operarioApertura: "Operario apertura",
    aperturasPorOperarios: "Cuentas abiertas por operario",
    aperturasPorOperariosMinuscula: "cuentas abiertas por operario",
    aperturasOperarios: "Cuentas abiertas",
    productosPorAperturaDe: "Productos por apertura de",
    productosPorApertura: "Productos por apertura",
    facturasEmitidasMinuscula: "facturas emitidas",

    //18/08/21
    restriccionesProductos: "Restricciones por producto",
    restriccionesProductosDesc: "Configurar restricciones horarias para la venta de productos",
    //19/08/21
    noHayRestriccionesParaProductos: "No hay restricciones horarias para productos en este negocio.",
    alcohol: "Alcohol",
    //20/08/21
    inforestriccionesproducto: "Una vez que haya creado la restriccion de venta horaria, podra asignarla en la configuracion de los productos.",
    noMostrarDescuento: "No mostrar descuentos",

    //17/08/2021
    rangosDeMesas: "Rangos de mesas",
    agrupacionesDeMesasParaConsultarVentas: "Agrupaciones de mesas para consultar ventas",
    verUnInformeDeRangosDeMesas: "Ver informe de rangos de mesas",
    nuevoRangoMesa: "Nuevo rango mesa",
    mesaInicial: "Mesa inicial",
    mesaFinal: "Mesa final",
    noHayRangosDeMesasEnEsteTpv: "No hay rangos de mesas en este TPV",
    nombreRangoDeMesas: "Nombre rango de mesas",
    borrarRangoMesas: "Borrar rango de mesas",
    deseaEliminarEsteRangoDeMesas: "¿Desea eliminar este rango de mesas?",
    siBorrarEsteRangoDeMesas: "Sí, borrar este rango de mesas",
    ventasPorRangoDeMesas: "Ventas por rango de mesas",
    porRangoDeMesas: " por rango de mesas",
    numeroDeOperaciones: "Número de operaciones",
    precioMedioPorOperacion: "Precio medio por operación",
    propuestoParaCierre: "Propuesto para cierre",
    esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo: "Este ticket ha sido propuesto para su cierre, ¿está usted de acuerdo?",
    siCerrarTicket: "Sí, cerrar ticket",
    propuestaDeCierreDeTicket: "Propuesta de cierre de ticket",
    noEstoyDeAcuerdo: "No estoy de acuerdo",
    ultimaRespuestaDelEquipoTecnico: "Última respuesta del equipo técnico",
    escribaAquiSuRespuesta: "Escriba aquí su respuesta",
    enviarRespuesta: "Enviar Respuesta",
    tienesTicketsPendientesDeCerrar: "Tienes tickets pendientes de cerrar",

    //27/08/2021
    cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV: "Cuando un producto es de tipo Menú, se crea un Menú que se sincroniza con el TPV",
    platosDelMenu: "Platos del menú",
    productosDelMenu: "Productos del menú",
    paraConfigurarUnProductoComoTipoMenu: "Para configurar un producto como tipo Menú, primero debe guardar el producto",
    ocultarSaldo: "Ocultar productos relacionados con saldo",

    //26/08/21
    resActiva: "Activada",
    resInactiva: "Desactivada",

    //26/08/2021
    exportarExcelDeTodosLosTickets: "Exportar Excel de todos los tickets",
    soloPuedesSacarInformesDeUnMesComoMaximo: "Solo puedes sacar informes de un mes como máximo",
    loSentimos: "Lo sentimos",
    noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas: "No tienes ningun rango de mesas creado. ¿Deseas crear un rango de mesas?",
    siCrearUnRangoMesas: "Sí, crear un rango mesas",

    // 07/08/2021
    usuarioSinAcceso: "Su usuario no tiene acceso a este modulo",

    //08/09/21
    pedidosHoras: "Pedidos por horas",
    graficaPedidosHoras: "Gráfica que muestra el número de pedidos agrupado por tramo horario en el dia de hoy",

    //20/09/21
    personalizacionCarta: "Personalizacion de la Carta Online",
    personalizacionCarta: "Personaliza tu carta ",
    personalizacion: "Personalización",
    conLasOpcionesQueTeOfrecemos: "con las opciones que te ofrecemos",
    opcionesConfiguracion: "Opciones de configuración",
    vistaPrevia: "Vista previa",
    imagenCargando: "Imagen de carga",

    //21/09/21
    diagnosis: "Diagnosis",
    diagnosticoProductos: "Diagnóstico de productos",
    comprobacionProducts: "Comprobación de productos",
    diagnosticarProductos: "Diagnosticar productos",
    productosSinRelacionEnElTpv: "¡Todo correcto!",
    pulseElBoton: "Pulse el botón deseado",
    paraRealizarDiagnosis: "para realizar la diagnosis",
    productoRelacionadoConTpv: "Relacionado en el TPV con",
    noTieneRelacion: "No tiene relacion",
    hayProductosSinRelacion: "Hay productos que no estan relacionados en el TPV",

    //20/09/21
    destacadosTitulo: "Titulo destacado",
    nuevoTitulo: "Nuevo titulo",
    tituloActual: "Titulo actual",

    //22/09/21
    textos: "Textos",

    //21/09/21
    facturas: "Facturas",
    facturasMinusculas: "facturas",
    facturacionGeneral: "Facturación general",
    deTodasLasSeries: " de todas las series",

    //29/09/21
    permisoBusinessGestion: "Lo sentimos. No tienes permiso para utilizar esta herramienta en el negocio actual",
    permisoUsuarioGestion: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    traduccion: "Traducción",
    traduccionDe: "Traducción de",
    idioma: "Idioma",
    losDescuentosDeLasVentasEstanAlCeroDeIva: "Los descuentos de las ventas están al 0% de iva",
    recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo: "Recuerde que al realizar cobros avanzados los comensales se asignaran a la forma de pago efectivo",
    mapasYZonas: "Mapas y zonas",
    idiomas: "Idiomas",
    permisoControlIdiomas: "Lo sentimos, este negocio no cuenta con el control de idiomas activado.",
    idiomasCartaTip1: "Para activar o desactivar un idioma puedes hacer clic en los interruptores.",
    idiomasCartaTip2: "Para ordenar los idiomas en la carta, puedes utilizar el campo orden.",
    idiomasCartaTip3: "Los idiomas con un orden menor aparecerán primero.",
    menu: "Menú",

    //30/11/21
    totalVentasDevueltos: " total ventas y devueltos",

    //  24/11/21
    tpvOrigen: "Tpv de origen",
    validez: "Validez (días)",
    dateConsumo: "fecha de Consumo",
    dateCreacion: "fecha de Emision",
    nombreTpvDestino: "tpv de canje",
    nombreTpvOrigen: "TPV de Origen",
    hash: "CODIGO (hash)",
    nombreProveedor: "Proveedor",

    //14/12/2021
    apuntes: "Apuntes",
    apunte: "Apunte",
    cuentaContableGastos: "Cuenta contable gastos",
    cuentaContableApuntes: "Cuenta contable apuntes",
    retrocederEstado: "Retroceder estado",

    //23/12/2021
    excluirDeSage: "Excluir de Sage",
    costeDeProductosPorAgencias: "Coste de productos por agencias",
    agrupadoPorAgencias: " agrupado por agencias",

    //27/10/21
    selectCategory: "Seleccione las categorias para la importación",
    errorCategorySelect: "ATENCIÓN",
    txtErrorCategorySelect: "Se ha cancelado la importación debido a que las categorias seleccionadas solo contienen menús.",

    //24/01/22
    consultarPorAperturaDeCuenta: "Consultar por apertura de cuenta",
    consultarPorCierreDeCuenta: "Consultar por cierre de cuenta",
    informeAperturaCuentas: "Informe apertura cuentas",
    informeCierreCuentas: "Informe cierre cuentas",
    activado: "Activado",
    desactivado: "Desactivado",
    rango: "Rango",
    pedidosPlataformaDePagoSinCompletar: "Pedidos plataforma de pago sin completar",
    estaAccionAnadiraUnPedidoEstaSeguro: "Esta acción añadirá un pedido, ¿Está seguro de que ha sido pagado?",
    estaAccionNoSePuedeDeshacerEstaSeguro: "Esta acción no se puede deshacer, ¿está seguro?",
    haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas: "Ha habido un pedido con este teléfono en la últimas 12 horas",
    interrogacionQuiere: "¿Quiere ",
    elPedidoTemporalInterrogacion: " el pedido temporal?",
    aceptarMinuscula: "aceptar",
    eliminarMinuscula: "eliminar",
    excluirPrecioMedioMenu: "Excluir del precio medio los productos vendidos en menús",

    //28/01/22
    categoriasPadre: "Categorías padre",
    categoriaPadre: "Categoría padre",
    quieresConvertirLaCategoria: "¿Quieres convertir la categoría",
    quieresQueLaCategoria: "¿Quieres que la categoría",
    enUnaCategoriaPadre: "en una categoría padre?",
    dejeDeSerUnaCategoriaPadre: "deje de ser una categoría padre?",
    porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion: "Por favor, añada una categoría padre antes de activar la configuración",
    deseaActivarLasCategoriasPadreParaLaCartaDigital: "¿Desea activar las categorías padre para la carta digital?",
    deseaDesactivarLasCategoriasPadreParaLaCartaDigital: "¿Desea desactivar las categorías padre para la carta digital?",
    recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
        "Recuerde que las categorías que no estén relacionadas a una categoría padre no aparecerán en Numier Pedidos",
    activadas: "ACTIVADAS",
    desactivadas: "DESACTIVADAS",
    categoriasPadreTextoExplicativo: "Las categorías padres sirven para agrupar las categorías de Numier Pedidos en agrupaciones mayores. Ejemplo: Puedes tener una categoría padre Primeros que contenga Carne, Pescado y Vegetariano",
    lasImagenesSoloSeraVisibleEnLasCategoriasPadre: "Las imágenes solo serán visibles en las categorías padre",

    //09/02/2022
    consultarInventarioPorSectores: "Consultar inventario por sectores",
    inicioReal: "Inicio real",
    precarga: "Precarga",
    mermas: "Mermas",
    finalBarra: "Final barra",
    porSectores: "por sectores",
    buscarPorRefONombreDelProducto: "Buscar por código de barras o nombre del producto",
    textoAyudaProductoCompleto: "Cuando esta opción se encuentra desmarcada se trabajará con materias primas",
    accion: "Acción",

    metodoLiquidacionSinqro: "Método liquidación Sinqro",
    metodoLiquidacionSinqroInfo: "La modificación de este campo debe solicitarse al soporte técnico.",
    horaRepartidorAsignado: "Hora repartidor asignado",
    envioProgramado: "Envío programado",
    tiempoEstimado: "Tiempo estimado",
    gastosEnvio: "Gastos envío",
    buscarPedidoPorCliente: "Buscar pedido por cliente...",
    obligatorioApellidos: "Obligatorio los dos campos de apellidos",

    //13/06/2022
    introduzcaElPorcentajeDeLaPrimeraCuentaContable: "Introduzca el porcentaje de la primera cuenta contable",
    porcentajeContable: "Porcentaje contable",

    //7/7/2022
    incidenciaOperario: "Incidencias por operario",
    deIncidenciaOperario: "de incidencias por operario",
    verIncidenciaOperario: "Ver Incidencias",
    Incidencia: "Incidencia",

    //11/07/2022
    nTickets: "Nº Ticket",
    propina: "Propina",
    serviceCharge: "Service Charge",

    //15/07/2022
    totalCompleto: "Total completo",

    //31/08/2022
    sinConsumir: "Sin consumir",

    //06/09/2022
    integraciones: "Integraciones",
    GStock: "G-Stock",

    //13/09/2022
    estasSeguroDeExportarLasVentas: "¿Estás seguro de exportar las ventas a G-Stock?",
    ventasExportadasExsitosamente: "Ventas exportadas con éxito",

    //04/10/2022
    referenciaYaExiste: "La referencia coincide con la de otro gasto",
    continuar: "¿Continuar?",
    guardarGasto: "Guardar gasto",
    maximoOpcionales: "Máximo opcionales",

    //04/11/2022
    totalImpuestoIva: "Total impuesto IVA",

    //09/11/2022
    enviarFacturaECorreo: "Enviar facatura electrónica por correo",

    //10/11/2022
    baseImponible: "Base imponible",
    cuotaIVA: "Cuota IVA",

    //17/11/2022
    identificador: "Identificador contable",

    //13/12/2022
    cambiarAgencia: "Cambiar agencia",
    facturaEditadaCorrectamente: "La factura se ha editado correctamente",
    editarNumeroComensales: "Editar número de comensales",
    buscarPorNombreDeAgencia: "Buscar por nombre de agencia",

    // 10/01/2023
    exportadoSage: "Exportado SAGE",
    updateExportadoSageCorrectamente: "Exportado SAGE actualizado correctamente",
    titleModificarExportadoSage: "Modificar exportado a SAGE",
    askUpdateExportadoSageTrue: "¿Está seguro que desea poner el gasto como exportado?",
    askUpdateExportadoSageFalse: "¿Está seguro que desea poner el gasto como NO exportado?",

    //01/02/2023
    ProgramacionCarta: "Planificador de la carta",
    guardados: "Guardados",
    publicados: "Publicados",
    dePublicacion: "de Publicación",
    sinPublicar: "Sin Publicar",
    publicado: "publicado",
    publicar: "Publicar",
    Ocultar: "Ocultar",
    Publicado: "Publicado",
    aliasMayuscula: "Alias",

    // 03/02/2023
    porcentajeRespectoTotal: "% respecto total",

    //13/02/2023
    ultimoPrecioCompra: "Último precio compra",

    //20/02/2023
    pagosaldo: "Pago saldo",

    //21/02/2023
    basePropina: "Base Propina",
    impuestoPropina: "Impuesto Propina",
    baseServiceCharge: "Base Service Charge",
    impuestoServiceCharge: "Impuesto Service Charge",

    //02/03/2023
    socios: "Socio",
    noSocios: "No socio",

    //20/04/2023
    productoCartaSinRelacionar: 'Sin relacionar',

    //21/04/2023
    precioTarifa: 'Precio / Tarifa 1',

    resetearDias: "Resetear Días",
    resetearButton: "Resetear",
    fechaIni: "Fecha de Inicio",
    fechaFin: "Fecha de Fin",
    reseteoExitoso: "Reseteo realizado correctamente",
    reseteoError: "Ha habido un error al realizar el reseteo",

    productosNoRelacionados: "Productos sin PLU",
    productosNoRelacionadosDescripcion: "Herramienta para encontrar productos sin PLU",

    //23/05/29023
    verDetallesDeCuentaAnulada: "Ver detalles de cuenta anulada",
    desgloseDeCuenta: "Desglose de cuenta",

    //29/03/2023
    exportarExcelValderrama: "Exportar Excel completo",

    //20/04/2023
    productoCartaSinRelacionar: 'Sin relacionar',

    //21/04/2023
    precioTarifa: 'Precio / Tarifa 1',

    //29/05/2023
    pendientePago: 'Pendiente de pago',
    fechaVencimiento: 'Fecha de vencimiento',
    pendientePagoCambiadoCorrectamente: 'Pendiente de pago cambiado correctamente',
    numeroTickets: 'Número tickets',

    //06/06/2023
    cliente: "Cliente",
    mensajePorcentajeCompraAumento: "El precio ha aumentado del porcentaje de compra establecido",
    mensajePorcentajeCompraDisminuido: "El precio ha disminuido del porcentaje de compra establecido",
    avisoPorcentajeCompra: "Aviso de porcentaje de compra",

    //19/06/2023
    conIvaDesglosado: "con IVA desglosado",

    //21/06/2023
    ventasPorProductos: "Ventas por productos",
    sinRecoger: "Sin recoger",
    sinDomicilio: "Sin domicilio",
    recogerEnPedidos: "Recoger",
    domicilioEnPedidos: "Domicilio",
    informeDeVentasDeProductosDePedidos: "Informe de ventas de productos de pedidos",

    //22/06/2023
    numeroPedidosDomicilio: "Nº pedidos domicilio",
    numeroPedidosRecoger: "Nº pedidos recoger",

    //25/07/2023
    exportarSage200Fechas: "Exportar Sage200 por fechas",
    fechas: "Fechas",
    soloExportarGastos: "Solo exportar gastos",

    //05/09/2023
    noMostrarInformeSectores: "No mostrar informe sectores",
    totalCargar: "Total a cargar",
    deshabilitar: "Deshabilitar",
    noMostrar: "No Mostrar",

    //19/09/2023
    verificarTodo: "Verificar todo",
    estaSeguroDeVerificarTodosLosGastos: "¿Estás seguro de verificar todos los gastos?",
    gastosVerificadosCorrectamente: "Gastos verificados correctamente",

    //26/09/2023
    siVerificarGastos: "Sí, verificar gastos",
    seleccionarTodosDelMismoProveedor: "Seleccionar todos del mismo proveedor",

    //28/09/2023
    mostrarSinIva: "Mostrar sin IVA",
    modificarPrecio: "Modificar precio",

    //05/10/2023
    nDeComensales: "Nº de comensales",

    //13/10/2023
    archivoEnFormatoExcel: "Archivo en formato Excel",
    importarExcelClientes: "Importar Excel clientes",
    importarExcelSaldoClientes: "Importar Excel saldo clientes",
    importarClientes: "Importar clientes",

    //31/10/2023
    ticketMedioRecoger: "Ticket medio recoger:",
    ticketMedioDomicilio: "Ticket medio domicilio:",

    //23/11/2023
    ultimoPrecioCompraSinIva: "Último precio compra sin IVA",

    //08/01/2024
    ventaDeProductosPorRangoDeMesas: "Ventas de productos por rango de mesas",
    filtradoPorRangoDeMesas: " filtrado por rango de mesas",
    vecesQueSeHaVendidoDentroDeMenus: "Veces que se ha vendido dentro de menús",
    delMenu: "del menú",
    cEnMenus: "C. en Menús",
    cFueraDeMenus: "C. Fuera de Menús",
    rangoDeMesas: "Rango de mesas",

    //10/01/2024  
    //ToolTip 
    tolTipLogo : "Añade el logo de tu restaurante para que aparezca en la pantalla de inicio y en tu tarjeta QR. El tamaño recomendado es de 90 x 90 px.",
    tolTipFondo: "Añade una foto de alta calidad para que aparezca como portada en tu menú QR. El tamaño recomendado es de 1280 x 1024 px",
    tolTipImagenProducto: "Añade una imagen de alta calidad para mostrar tu producto de manera visual y atractiva. Para productos en el menú, crea uno nuevo con una resolución ideal de 500 x 500 píxeles o 12 cm x 12 cm.",
    tolTipNombreMostrado : "Escribe aquí el nombre que quieres que se muestre de tu negocio.",
    tolTipEmail : "Facilita un Email de contacto para tus cliente.",
    tolTipTelefono : "Facilita un teléfono de contacto.",
    tolTipDescripcion : "Describe brevemente tu restaurante: el concepto y la experiencia que ofreces.",
    tolTipDireccion : "Facilita la dirección del restaurante que perteneza a esta carta.",
    tolTipPresentacion : "Escribe una llamada a la acción adecuada para que tus clientes quieran abrir tu tarjeta en la pantalla de inicio.",
    tolTipHorario: "Presenta tu horario o comparte información extra (vacaciones, fuera de servicio...).",
    tolTipMostrarCategoriaDeBaja: "Si marcas la casilla, se mostrarán las categorías que has dado de baja, pero no aparecerán en tu carta.",
    tolTipMostrarProductoDeBaja: "Si marcas la casilla, se mostrarán los productos que has dado de baja, pero no aparecerán en tu carta.",
    tolTipTraducirCategoria: "Traducir al idioma que quieras el título de las categorías",
    tolTipConvertirCategoriaPadre: "Convertir en categoría padre",
    tolTipOrdenCategorias: "Si quieres que aparezca esta categoria como la primera, el número debería ser “1”, y así consecuentemente según el orden.",
    tolTipBajaCategoria: "Al activar esta opción, la categoría seleccionada dejará de aparecer en tu menú digital cuando los clientes accedan a él. La desactivación de una categoría implica que todos los productos que hayas incluido bajo esa categoría específica también dejarán de ser visibles para tus clientes.",
    tolTipVerQr: "Accede y descarga el código QR de tu carta",
    tolTipDisponibleProducto: "Marcar la disponibilidad del producto: Indica si un producto está disponible o no en tu carta.",
    tolTipIdiomaProducto: " Elige el idioma en el que también quieres que se presente el producto",
    tolTipOrdenProducto: "Elige el orden en que deseas que aparezca el producto dentro de la categoría seleccionada.",
    tolTipProductoDestacado: " Si seleccionas esta opción, el producto aparecerá en un apartado destacado al inicio de la carta. Resalta productos especiales o promociones.",
    tolTipBaja: "Este producto no se mostrará en tu carta (si está activado).",
    tolTipDisponible: "Activa el botón si el producto está disponible para la venta. Desactiva si el producto está 'Fuera de Stock' (cuando no hay existencias)''.",
    tolTipImagenCarga: "imagen que se mostrará durante los breves segundos en que tu carta se carga.",
    tolTipTituloDestacado: "Aquí puedes definir el texto que nombrará la sección de productos destacados. Ej: 'Sugerencias del Chef', 'Nuestros Top Ventas' o 'No te Puedes Perder' .",
    tolTipIdiomaMateriaPrima: "Elige el idioma en el que también quieres que se presente la materia prima",
    guiaUsuario: "Guía de usuario",

    //14/02/24
    pedidosPorRepartidores: "Pedidos por repartidores",
    nombreRepartidor: "Nombre del repartidor",
    cantidadDePedidos: "Cantidad de pedidos",

    //13/02/2024
    herramientaControlStockControlComprasInventarios: "Herramienta de control de stock, control de compras e inventarios",
    fidelizacion: "Fidelización",
    cheerfy: "Cheerfy",
    plataformaGestionPromocionesClientes: "Plataforma de gestion de promociones de clientes",
    nuevaPromocion: "Nueva promoción",
    noHayPromocionesEnEsteTpv: "No hay promociones en este tpv",
    tolTipDisponiblePromocion: "Marcar la disponibilidad de la promoción: Indica si la promoción está disponible o no.",
    promocion: "promoción",
    fechaCreacion: "Fecha creación",
    activo: "Activo",
    inactivo: "Inactivo",
    borrarPromocion: "Borrar promoción",
    promociones: "Promociones",
    codigoPromocion: "Código promoción",
    elCampoCodigoEsRequerido: "El campo codigo es requerido",
    deseaEliminarEstaPromocion: "¿Desea eliminar esta promoción?",
    siBorrarEstaPromocion: "Sí, borrar esta promocion",

    //12/03/24
    basesFree : "Bases extras gratis",
    extrasFree : "Bases / Extras gratis",
    tooltipBaseExtra: "Si la base está activada, no suma extra gratis. Si el extra está activado, no contará como gratis al añadirse.",

    //09/04/24
    permisoControlModulos: "Lo sentimos. Este negocio no cuenta con este módulo activado.",
    calcularCosteTodosLosProductos: "Calcular coste de todos los productos",
    trabajarSinIva: "Trabajar sin IVA",
    filtrarPorAgencias: "Filtrar por agencia",
    seleccioneLaTarifaParaMostrarSuNombre: "Seleccione la tarifa para mostrar su coste",
    conIVA: "Con IVA",
    calcular: "Calcular",
    productosIncluidosConEsteMenu: "Productos incluidos con este menú",
    abonarFacturaQr: "Abonar Factura QR",
    deseasAbonarEstaFacturaQR: "¿Deseas abonar esta factura QR?",
    abonarFactura: "Abonar factura",

    exportar: "Exportar",
    codigoBarras: "Código de barras",
    codBarras: "C.Barras",

    //18/08/24
    listadoTicketRepartidor: "Tickets por repartidor",

    //WALLET
    passbooks: "Passbooks",
    sharePassbooks: "Compartir wallets",
    copyToClipboard: "Copiar al portapapeles",
    shareViaEmail: "Enviar por e-mail",
    shareViaWhatsapp: "Enviar por Whatsapp",
    copied: 'Copiado al portapapeles',
    selectBusinessForWallet: 'Elige el negocio para el que desear enviar las Wallets',
    sendMethod: 'Método de envío',
    share: "Enviar",
    sendAndSaveButton: 'Sí, enviar y guardar',
    sendAndNoSaveButton: 'No, enviar y no guardar',
    titleSaveInfoModalText: 'La información del cliente ha cambiado ¿desea guardar esta información?',
    verifyNumberText: 'Verifique el teléfono',
    verifyEmailText: 'Verifique el e-mail',
    selectOption: 'Seleccione una opción',
    clipboardCopied: 'Copiado al portapapeles',
    clipboardFailedToCopy: 'El API del portapapeles no está disponible en este navegador.',
    enviarWallet: 'Enviar Wallet',
    confirmacionEnvioWallet: 'Confirmación de Envío de Wallet',
    confirmacionTextoEnviarWallet: '¿Está seguro de que desea enviar la wallet a todos los clientes?',
    mensajeConfirmacion: "Esta acción no se puede deshacer y sólo se enviará a los clientes cuyo email esté agregado y posean un Código de barras.",
    enviar: "Enviar",
    noHayCorreosElectronicos: "No hay correos electrónicos.",
    ningunClienteConCorreoElectronico: "No se encontró ningún cliente con correo electrónico configurado.",
    clientHasNoBarcode: "El cliente no tiene un código de barras establecido.",
    exportarCarta: "Exportar Carta",
    exportarSimplifiedExcel: "Exportar como Excel (Sin cabeceras)",

    //GESTIÓN DE IMPUESTOS
    taxes: "Impuestos",
    tax: "Impuesto",
    gestionImpuestos: "Gestión de Impuestos",
    administracionTiposTasas: "Administración",
    administracionTiposTasasImpositivas: " de tipos y tasas impositivas",
    agregarImpuesto: "Agregar Impuesto",
    taxRate: "Impuesto Aplicado",
    taxDescription: "Descripción",
    taxType: "Tipo de Impuesto",
    taxBoldType: "impuestos",
    impuestoAplicadoEsCero: "El Impuesto Aplicado no puede ser menor de ",
    impuestoYaCreado: "Este impuesto ya existe y no puede ser creado nuevamente",

    //IMPORTAR CLIENTES 
    previewClientData: "Previsualización",
    editarCliente: "Editar cliente",
    importarData: "Importar datos",
    importandoDatos: "Importando datos",
    preview: "Previsualizar",
    importacionRealizada: "Importación realizada",
    datosImportados: "Los datos se importaron correctamente",
    confirmarImportacion: "Confirmar importación",
    seguroContinuarImportacion: "¿Estás seguro de que quieres continuar? Esta acción es irreversible",

    //18/11/24
    //Update-Logo
    inserteImagen: "Inserte una imagen",
    seleccioneArchivoImagen: "Seleccione un archivo Imagen",
    archivoDemasiadoGrande: "El archivo es demasiado grande. El tamaño máximo permitido es 5MB.",
    dimensionesExcedenLimite: "Las dimensiones de la imagen exceden el límite permitido (2000x2000px).",
    mensajeconfirmacion: "Estás a punto de reemplazar la imagen existente. ¿Quieres guardar?",
    botonGuardar: "Guardar",
    botonCancelar: "Cancelar",
    Guardado: "Guardado",
    guardarOvisualizarLogo: "Visualizar o guardar logo",
    configurarLogoNegocio: "Configurar el logo del negocio",
    seleccionLogo: "Haz clic para seleccionar un logo",
    volver: "Volver",
    noExisteLogoNegocio: "No existe un logo para el negocio.",
    informacion: "Información: ",
    tamaño: "Tamaño: ",
    dimensiones: "Dimensiones: ",
    restriccionesLogo: "Restricciones del logo:",
    tamañoMaximo: "Tamaño max: ",
    dimensionesMaximas: "Dimensiones max: ",

    //13/12/24
    //ProductosNoRelacionados.NEW
    mensajeAviso: "¿Está seguro de que desea generar automáticamente los PLUs? Este proceso generará un código para cada producto y tarifa no configurados, y se guardará automáticamente.",
    mensajeAvisoSubProducto: "¿Está seguro de que desea generar automáticamente los PLUs? Este proceso generará un código para cada materia prima no configurada y se guardará automáticamente.",
    generarPlu: "Generar automaticamente PLUs",
    botonAceptar: "Aceptar",
    PLUsGenerados: "¡PLUs generados correctamente!",
    errorGenerandoPLUs: "Error al generar los PLUs",

    //21/01/2025
    nosmudamos: "¡Nos mudamos!",
    noscambiamosaselfi: "Tu negocio ha dado un gran paso: ahora su carta forma parte de la familia Selfibar. A partir de ahora, todas las configuraciones y gestiones, relativas a la carta, las podrás realizar directamente en Selfibar. ",
    esteNegocioEsSelfi:"Este negocio es Selfibar",
    paraContinuar:"Para continuar, haz clic en Selfibar y accede a tu cuenta de Selfibar con tu usuario y contraseña",
    irASelfibar: "Ir a selfibar",
    barcodeUnico: "Código de barras único",
    barcodeNecesarioSeActualizara: "El código de barras es necesario para esta acción y se actualizará para este cliente al enviar o copiar al portapapeles.",
    emailenviado: "Email Enviado",

    //ListadomateriaPrima-Proveedor.
    //14/01/25
    verListado: "Listado materias primas",
    listadoMateriaPrimaProveedor: "Listado materia prima por proveedor",
    noTiene: "No tiene ",
    esteProveedor: " este proveedor",
    proveedor: "Nombre del proveedor:   ",
    precioAcordado: "Precio Acordado con Proveedor",
    porcentajeAcordado: "Porcentaje acordado ",
    filtrarPorEtiqueta: "Filtrar por etiqueta: ",
    precioAcordadoGuardadoCorrectamente: "Precio fijado. Guardado correctamente!",
    fijarprecio: "Fijar precio ",
    preciofijado: "(Fijar el precio de la materia prima)",
    mensajePrecioFijado: "El precio de la materia prima es de  ",
    explicacionFijarPrecio: "Al activarlo, el precio de la materia prima y el porcentaje de descuento se quedarán fijado. Al hacer un nuevo gasto ni el precio ni el descuento se verán modificado.",
    porcentajeAcordado: "Porcentaje de aviso",
    porcentajeAcoradoGuardado: "Porcenaje acordado. Guardado correctamente!",
    losSubproductosSeHanIncrementado : "Se ha detectado un incremento en el precio de las siguientes materias primas con respecto al porcentaje acordado con el proveedor",
    errorverificar: "Error al verificar",
    mensajeErrorVerificarTodo: "Se ha detectado en los siguientes gastos un incremento en el precio de la materia prima con respecto al porcentaje acordado con el proveedor",
    explicacionPorcentajeAcordado: "Este es el porcentaje acordado para el proveedor, para el control del precio de las materias primas a la hora de realizar un gasto.",
    generarBusinessHash: "Generar URL para operarios",
    enlaceFicharTurnosOperario: "Acceso para fichar y consultar turnos",
    enlaceFicharTurnosOperarioDescripcion: "Los trabajadores del negocio podrán iniciar sesión con las mismas credenciales que en el TPV para registrar el inicio y fin de su turno, así como consultar los últimos 14 turnos realizados junto con sus tiempos.",

    //KIOSKOS
    kioskos: "Kioscos",
    stockBreak: "Rotura de stock",
    kiosksMenu: "Kioskos carta",
    barcode: "BARCODE",

    saldoAnterior: "SALDO PREV.",
    saldoActual: "SALDO ACTUAL",


};



// WEBPACK FOOTER //
// ./src/language/spain.js